/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 52);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(55);
var factory = __webpack_require__(58);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = __webpack_require__(32);

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(64)(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(65)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

var CustomRenderMixin, objectsEqual;

objectsEqual = function(objA, objB) {
  var aKey, aVal, bKey, bVal, keyValuesAreSame;
  if (objA === objB) {
    return true;
  }
  if ((objA == null) && objB || objA && (objB == null)) {
    return false;
  }
  for (aKey in objA) {
    aVal = objA[aKey];
    if (objA.hasOwnProperty(aKey) && !objB.hasOwnProperty(aKey)) {
      return false;
    }
    bVal = objB[aKey];
    keyValuesAreSame = aVal === bVal ? true : Immutable.Iterable.isIterable(aVal) && Immutable.Iterable.isIterable(bVal) ? aVal.equals(bVal) : _.isObject(aVal) && _.isObject(bVal) ? this.objectsEqual(aVal, bVal) : false;
    if (!keyValuesAreSame) {
      return false;
    }
  }
  for (bKey in objB) {
    if (objB.hasOwnProperty(bKey) && !objA.hasOwnProperty(bKey)) {
      return false;
    }
  }
  return true;
};

CustomRenderMixin = {
  shouldComponentUpdate: function(nextProps, nextState) {
    return !objectsEqual(nextProps, this.props) || !objectsEqual(nextState, this.state);
  }
};

module.exports = CustomRenderMixin;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var LngContext, StaticContentFromDraftJS, StaticHtmlContent, createReactClass;

StaticContentFromDraftJS = __webpack_require__(19);

createReactClass = __webpack_require__(0);

LngContext = __webpack_require__(9);

StaticHtmlContent = createReactClass({
  displayName: "StaticHtmlContent",
  createMarkup: function(content) {
    return {
      __html: content
    };
  },
  _setImagesSrc: function() {
    var regExp, srcSetter;
    regExp = /<img[^>]+db-image="([\S]+)"[^>]+src=("")/g;
    srcSetter = (function(_this) {
      return function(imageString, imageName, srcValue) {
        return imageString.replace(srcValue, _this._getDataURL(imageName));
      };
    })(this);
    if (this.props.content) {
      return this.props.content.replace(regExp, srcSetter);
    } else {
      return "";
    }
  },
  _getDataURL: function(imageName) {
    var content_type, data, imageAttachment, ref;
    imageAttachment = this.props.attachments.get(imageName);
    if (!imageAttachment) {
      return "\"\"";
    }
    ref = imageAttachment.toJS(), content_type = ref.content_type, data = ref.data;
    if (content_type && data) {
      return "\"data:" + content_type + ";base64," + data + "\"";
    } else {
      return "\"\"";
    }
  },
  render: function() {
    if (!this.props.content) {
      return React.createElement("div", {
        "className": "content static"
      }, React.createElement("br", null));
    }
    return React.createElement(LngContext.Consumer, null, ((function(_this) {
      return function(language) {
        var content, contentClasses;
        contentClasses = classNames("content", "static", {
          "text-rtl": language === 'fa' || language === 'ar'
        });
        if (typeof _this.props.content === 'string') {
          content = _this._setImagesSrc();
          return React.createElement("div", {
            "className": contentClasses,
            "dangerouslySetInnerHTML": _this.createMarkup(content)
          });
        } else {
          return React.createElement(StaticContentFromDraftJS, Object.assign({}, _this.props, {
            "className": contentClasses
          }));
        }
      };
    })(this)));
  }
});

module.exports = StaticHtmlContent;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

var Translation;

Translation = function(namespace) {
  if (namespace == null) {
    namespace = '';
  }
  return {
    _i18n: function(key, params) {
      var keyWithNamespace, levelsToGoUp, namespaceTree, normalizedKey;
      if (params == null) {
        params = {};
      }
      keyWithNamespace = key.startsWith('/') ? key.slice(1) : key.startsWith('../') ? (namespaceTree = namespace.split(/\.|:/), namespaceTree.length === 1 ? key : (levelsToGoUp = key.match(/\.\.\//g).length, normalizedKey = key.replace(/\.\.\//g, ''), namespaceTree.slice(0, namespaceTree.length - levelsToGoUp).concat([normalizedKey]).join('.').replace('.', ':'))) : namespace.length ? namespace + "." + key : key;
      return $.t(keyWithNamespace, params);
    },
    i18n: function(key, params, componentParams) {
      var component, fragments, paramKey, replaceWithComponent, string;
      if (params == null) {
        params = {};
      }
      if (componentParams == null) {
        componentParams = null;
      }
      string = this._i18n(key, params);
      if (componentParams) {
        fragments = [];
        replaceWithComponent = function(string, key, component) {
          var componentParamKeyString, split;
          componentParamKeyString = componentParamKey(paramKey);
          if (string.includes(componentParamKeyString)) {
            split = string.split(componentParamKeyString);
            fragments.push(split[0]);
            fragments.push(component);
            return split[1];
          } else {
            return string;
          }
        };
        for (paramKey in componentParams) {
          component = componentParams[paramKey];
          string = replaceWithComponent(string, paramKey, component);
        }
        fragments.push(string);
        return fragments.map(function(fragment, idx) {
          if (_.isString(fragment)) {
            return fragment;
          } else {
            return React.createElement(React.Fragment, {
              key: idx
            }, fragment);
          }
        });
      } else {
        return string;
      }
    }
  };
};

module.exports = Translation;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(37);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

var LngContext;

LngContext = React.createContext();

module.exports = LngContext;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21),
    getRawTag = __webpack_require__(92),
    objectToString = __webpack_require__(93);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(101),
    listCacheDelete = __webpack_require__(102),
    listCacheGet = __webpack_require__(103),
    listCacheHas = __webpack_require__(104),
    listCacheSet = __webpack_require__(105);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(14);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(125);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var Assessment, Background, Decision, DetailedJustification, Implementation, Justification, MonitoringAndEvaluation, PatientsTab, RelatedRecommendations, SECTIONS_FROM_ETD, SectionTabs, SubgroupConsiderations, SummaryOfFindings, Tabs, array, arrayOf, bool, createReactClass, instanceOf, isEditable, ref, string,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Assessment = __webpack_require__(54);

Background = __webpack_require__(68);

Decision = __webpack_require__(73);

DetailedJustification = __webpack_require__(34);

Implementation = __webpack_require__(74);

Justification = __webpack_require__(75);

MonitoringAndEvaluation = __webpack_require__(76);

SubgroupConsiderations = __webpack_require__(77);

SummaryOfFindings = __webpack_require__(35);

PatientsTab = __webpack_require__(80);

RelatedRecommendations = __webpack_require__(81);

Tabs = __webpack_require__(33);

createReactClass = __webpack_require__(0);

ref = __webpack_require__(1), bool = ref.bool, isEditable = ref.isEditable, instanceOf = ref.instanceOf, array = ref.array, arrayOf = ref.arrayOf, string = ref.string;

SECTIONS_FROM_ETD = ['justification', 'subgroupConsiderations', 'monitoringAndEvaluation', 'implementationConsiderations'];

SectionTabs = createReactClass({
  displayName: "SectionTabs",
  propTypes: {
    isEditable: bool.isRequired,
    showSof: bool.isRequired,
    sections: instanceOf(Immutable.Map).isRequired,
    sectionTabs: arrayOf(string).isRequired,
    references: instanceOf(Immutable.List),
    relatedQuestions: instanceOf(Immutable.Map).isRequired,
    relatedRecommendations: instanceOf(Immutable.Map).isRequired
  },
  getDefaultProps: function() {
    return {
      references: Immutable.List()
    };
  },
  render: function() {
    var conclusionSectionKeys, conclusions, isofData, ref1, relatedQuestions, sectionId, sectionTabs, sections, showSof;
    ref1 = this.props, conclusions = ref1.conclusions, isofData = ref1.isofData, showSof = ref1.showSof, sections = ref1.sections, relatedQuestions = ref1.relatedQuestions, sectionTabs = ref1.sectionTabs;
    conclusionSectionKeys = conclusions.keySeq();
    sections = sections.filter(function(_section, key) {
      if (indexOf.call(SECTIONS_FROM_ETD, key) >= 0) {
        return conclusionSectionKeys.includes(key);
      } else {
        return true;
      }
    });
    sections = isofData && showSof ? sections : sections["delete"]('summaryOfFindings');
    sections = relatedQuestions.isEmpty() ? sections["delete"]('relatedRecommendations') : sections;
    sections = _.isArray(sectionTabs) && _.isEmpty(sectionTabs) ? sections : _.isArray(sectionTabs) ? sections.filter(function(section, sectionKey) {
      return indexOf.call(sectionTabs, sectionKey) >= 0;
    }) : null;
    if (!sections) {
      return null;
    }
    sectionId = sections.get('id');
    return React.createElement("div", null, (sectionId != null ? React.createElement("h4", null, sectionId) : void 0), React.createElement("div", {
      "className": "main-tabs"
    }, React.createElement(Tabs.List, {
      "initiallyActive": 0
    }, sections.map(this.createTab).toList())));
  },
  createTab: function(section, sectionId) {
    return React.createElement(Tabs.Tab, {
      "caption": section.get('name'),
      "key": sectionId
    }, this.renderSectionTab(sectionId));
  },
  renderSectionTab: function(sectionId) {
    switch (sectionId) {
      case 'assessment':
        return React.createElement(Assessment, {
          "actions": this.props.actions,
          "assessment": this.props.assessment,
          "assessmentSections": this.props.assessmentSections,
          "attachments": this.props.attachments,
          "currentEditable": this.props.currentEditable,
          "isEditable": this.props.isEditable,
          "references": this.props.references
        });
      case 'background':
        return React.createElement(Background, {
          "actions": this.props.actions,
          "assessmentSections": this.props.assessmentSections,
          "backgroundDetailSections": this.props.backgroundDetailSections,
          "currentEditable": this.props.currentEditable,
          "id": "background",
          "isEditable": this.props.isEditable,
          "presentationData": this.props.presentationData,
          "question": this.props.question,
          "questionData": this.props.questionData,
          "references": this.props.references,
          "sections": this.props.sections,
          "type": this.props.type
        });
      case 'decision':
        return React.createElement(Decision, {
          "currentEditable": this.props.currentEditable,
          "actions": this.props.actions,
          "isEditable": this.props.isEditable,
          "decision": this.props.sections.get('decision')
        });
      case 'detailedJustification':
        return React.createElement(DetailedJustification, {
          "id": "detailedJustification",
          "type": this.props.type,
          "assessmentSections": this.props.assessmentSections,
          "conclusions": this.props.conclusions.get('justification', Immutable.Map())
        });
      case 'implementation':
      case 'implementationConsiderations':
        return React.createElement(Implementation, {
          "actions": this.props.actions,
          "currentEditable": this.props.currentEditable,
          "isEditable": this.props.isEditable,
          "conclusions": this.props.conclusions.get('implementationConsiderations', Immutable.Map()),
          "type": this.props.type
        });
      case 'justification':
        return React.createElement(Justification, {
          "type": this.props.type,
          "actions": this.props.actions,
          "assessmentSections": this.props.assessmentSections,
          "conclusions": this.props.conclusions.get('justification', Immutable.Map()),
          "currentEditable": this.props.currentEditable,
          "id": "justification",
          "isEditable": this.props.isEditable,
          "presentationData": this.props.presentationData,
          "references": this.props.references
        });
      case 'monitoringAndEvaluation':
        return React.createElement(MonitoringAndEvaluation, {
          "actions": this.props.actions,
          "conclusions": this.props.conclusions.get('monitoringAndEvaluation', Immutable.Map()),
          "currentEditable": this.props.currentEditable,
          "isEditable": this.props.isEditable,
          "references": this.props.references
        });
      case 'subgroupConsiderations':
        return React.createElement(SubgroupConsiderations, {
          "actions": this.props.actions,
          "conclusions": this.props.conclusions.get('subgroupConsiderations', Immutable.Map()),
          "currentEditable": this.props.currentEditable,
          "id": "subgroupConsiderations",
          "isEditable": this.props.isEditable,
          "presentationData": this.props.presentationData,
          "references": this.props.references
        });
      case 'summaryOfFindings':
        return React.createElement(SummaryOfFindings, {
          "isEditable": false,
          "isofData": this.props.isofData,
          "comparatorIsofData": this.props.comparatorISofData,
          "onSavePlainLanguageStatement": this.props.onSavePlainLanguageStatement
        });
      case 'whyThisRecommendation':
      case 'whatItMeansForYou':
      case 'whoIsThisFor':
        return React.createElement(PatientsTab, {
          "actions": this.props.actions,
          "isEditable": this.props.isEditable,
          "sectionData": this.props.sections.get(sectionId, Immutable.Map()),
          "sectionId": sectionId
        });
      case 'relatedRecommendations':
        return React.createElement(RelatedRecommendations, {
          "relatedQuestions": this.props.relatedQuestions,
          "relatedRecommendations": this.props.relatedRecommendations
        });
    }
  }
});

module.exports = SectionTabs;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var AtomicBlockUtils, ContentState, CustomRenderMixin, DangerousContainer, Editor, EditorState, EmbeddedImageComponent, Entity, GdtEditor, InsertedGdtTable, PropTypes, ReferenceCitation, RichUtils, StaticContentFromDraftJS, convertFromRaw, convertToHtml, createReactClass, editorUtils;

CustomRenderMixin = __webpack_require__(2);

createReactClass = __webpack_require__(0);

PropTypes = __webpack_require__(1);

InsertedGdtTable = window.Editor.InsertedGdtTable;

EmbeddedImageComponent = window.Editor.EmbeddedImageComponent;

DangerousContainer = window.Editor.DangerousContainer;

ReferenceCitation = window.Editor.ReferenceCitation;

editorUtils = window.Editor.EditorUtils;

GdtEditor = window.Editor.Editor;

Editor = Draft.Editor, EditorState = Draft.EditorState, ContentState = Draft.ContentState, Entity = Draft.Entity, RichUtils = Draft.RichUtils, AtomicBlockUtils = Draft.AtomicBlockUtils, convertFromRaw = Draft.convertFromRaw, convertToHtml = Draft.convertToHtml;

StaticContentFromDraftJS = createReactClass({
  displayName: "StaticContentFromDraftJS",
  propTypes: {
    attachments: PropTypes.instanceOf(Immutable.Map),
    className: PropTypes.string,
    customBlockMapEntries: PropTypes.object,
    customEntityRenderers: PropTypes.object,
    references: PropTypes.instanceOf(Immutable.List)
  },
  getDefaultProps: function() {
    return {
      attachments: Immutable.Map(),
      className: "",
      customBlockMapEntries: {},
      customEntityRenderers: {},
      references: Immutable.List()
    };
  },
  getReferenceCitationDecorator: function() {
    return {
      strategy: editorUtils.findTextByEntityType('REFERENCE'),
      component: ReferenceCitation,
      props: {
        references: this.props.references
      }
    };
  },
  _getCustomEntityRenderers: function() {
    return {
      'GDT_TABLE': function(Editor) {
        return {
          component: InsertedGdtTable,
          editable: false,
          props: {
            focusEditor: Editor.focus,
            updateData: this.updateEntityData,
            isEditing: Editor.state.isEditing
          }
        };
      }
    };
  },
  updateEntityData: function(entityKey, newData) {
    this.gdtEditor.focus();
    return editorUtils.updatedEntityData(entityKey, newData);
  },
  _getEmbeddedImageSrc: function(imageId) {
    var content_type, data, imageAttachment, ref;
    imageAttachment = this.props.attachments.get(imageId);
    if (!imageAttachment) {
      return null;
    }
    ref = imageAttachment.toJS(), content_type = ref.content_type, data = ref.data;
    return "data:" + content_type + ";base64," + data;
  },
  render: function() {
    return React.createElement("div", {
      "className": this.props.className
    }, React.createElement(GdtEditor, {
      "readOnly": true,
      "ref": ((function(_this) {
        return function(el) {
          return _this.gdtEditor = el != null ? el.gdtEditor : void 0;
        };
      })(this)),
      "editorContent": this.props.content,
      "attachments": this.props.attachments,
      "blockRenderMap": editorUtils.getBlockRenderMap(this.props.customBlockMapEntries),
      "customDecorators": this.getReferenceCitationDecorator(),
      "customEntityRenderers": this._getCustomEntityRenderers()
    }));
  }
});

module.exports = StaticContentFromDraftJS;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, ForDecisionContent, GdtEditorWithApply, Translation, bool, createReactClass, func, instanceOf, object, ref, string;

CustomRenderMixin = __webpack_require__(2);

Translation = __webpack_require__(4);

ref = __webpack_require__(1), bool = ref.bool, string = ref.string, instanceOf = ref.instanceOf, object = ref.object, func = ref.func;

createReactClass = __webpack_require__(0);

GdtEditorWithApply = Editor.EditorWithApply;

ForDecisionContent = createReactClass({
  displayName: "ForDecisionContent",
  propTypes: {
    isEditable: bool.isRequired,
    sectionName: string,
    save: func.isRequired
  },
  mixins: [CustomRenderMixin, Translation('')],
  defaultProps: {
    sectionName: ""
  },
  onApply: function() {
    return this.saveContent();
  },
  saveContent: function() {
    return this.props.save(this.gdtEditor.getEditorContent());
  },
  onCancel: function() {
    return this.gdtEditor.resetContent(this.props.content);
  },
  getEditorEl: function(el) {
    return this.gdtEditor = el != null ? el.gdtEditor : void 0;
  },
  render: function() {
    var content, ref1, sectionName, sectionTitle;
    ref1 = this.props, content = ref1.content, sectionName = ref1.sectionName;
    sectionTitle = this.i18n('presentations:section_titles.for_decision', {
      'sectionName': sectionName
    });
    return React.createElement("div", null, React.createElement("h4", null, sectionTitle), React.createElement("div", {
      "className": "draft-editor"
    }, React.createElement(GdtEditorWithApply, {
      "ref": this.getEditorEl,
      "stickControlsTo": '#presentations',
      "editorContent": content,
      "onCancel": this.onCancel,
      "onApply": this.onApply,
      "onBlur": this.saveContent,
      "readOnly": !this.props.isEditable
    })));
  }
});

module.exports = ForDecisionContent;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(7);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(111),
    getValue = __webpack_require__(115);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(10),
    isObject = __webpack_require__(6);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(40);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(24),
    isLength = __webpack_require__(44);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var mapIconToKey, mapRecommendationToKey, mapRecommendationToLabel;

mapRecommendationToKey = function(recommendation) {
  switch (recommendation) {
    case 'suggest_against':
    case 'suggest':
    case 'cover_with_evidence':
      return 'conditional';
    case 'restricted_coverage':
    case 'postpone':
    case 'implement_with_evaluation':
      return 'conditional';
    case 'recommend_against':
    case 'recommend':
    case 'cover':
    case 'do_not_cover':
    case 'do_not_implement':
    case 'implement':
      return 'strong';
    case 'suggest_either':
    case 'cover_with_price':
    case 'conduct_pilot_study':
      return 'either';
  }
};

mapRecommendationToLabel = function(recommendation) {
  switch (recommendation) {
    case 'suggest_against':
    case 'cover_with_evidence':
    case 'postpone':
      return 'conditional_against';
    case 'suggest':
    case 'restricted_coverage':
    case 'implement_with_evaluation':
      return 'conditional_for';
    case 'recommend_against':
    case 'do_not_cover':
    case 'do_not_implement':
      return 'strong_against';
    case 'recommend':
    case 'cover':
    case 'implement':
      return 'strong_for';
    case 'suggest_either':
    case 'cover_with_price':
    case 'conduct_pilot_study':
      return 'either';
  }
};

mapIconToKey = function(key) {
  switch (key) {
    case 'whyThisRecommendation':
      return 'question-mark';
    case 'benefitsAndHarms':
      return 'plus-minus';
    case 'additionalInformation':
      return 'exclamation-mark';
    case 'whatYouCanDo':
      return 'compas';
    case 'speakWithHCProfessional':
      return 'person';
    default:
      return '';
  }
};

module.exports = {
  mapIconToKey: mapIconToKey,
  mapRecommendationToKey: mapRecommendationToKey,
  mapRecommendationToLabel: mapRecommendationToLabel
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var CollapsiblePanel, createReactClass;

createReactClass = __webpack_require__(0);

CollapsiblePanel = createReactClass({
  displayName: "CollapsiblePanel",
  getInitialState: function() {
    var ref, ref1;
    return {
      collapsed: (ref = (ref1 = this.props) != null ? ref1.collapsed : void 0) != null ? ref : false
    };
  },
  toggle: function() {
    return this.setState({
      collapsed: !this.state.collapsed
    });
  },
  renderPanel: function(panelClassName) {
    if (this.state.collapsed) {
      return React.createElement("div", {
        "className": panelClassName
      });
    } else {
      return React.createElement("div", {
        "className": panelClassName
      }, this.props.children);
    }
  },
  render: function() {
    var triggerClassName;
    triggerClassName = this.state.collapsed ? 'collapsed' : 'expanded';
    return React.createElement("div", {
      "className": this.props.className
    }, React.createElement("p", {
      "className": triggerClassName,
      "onClick": this.toggle
    }, React.createElement("span", {
      "className": "icon"
    }), this.props.title), this.renderPanel(triggerClassName));
  }
});

module.exports = CollapsiblePanel;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = __webpack_require__(18);
  var loggedTypeFailures = {};
  var has = __webpack_require__(31);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(62);
} else {
  module.exports = __webpack_require__(63);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var List, PropTypes, Tab, createReactClass;

PropTypes = __webpack_require__(1);

createReactClass = __webpack_require__(0);

List = createReactClass({
  displayName: "Tab:List",
  getInitialState: function() {
    var ref;
    return {
      active: (ref = this.props.initiallyActive) != null ? ref : 0
    };
  },
  _switchTab: function(idx) {
    return (function(_this) {
      return function(e) {
        e.preventDefault();
        return _this.setState({
          active: idx
        });
      };
    })(this);
  },
  _tabChanged: function(from, to) {
    var base;
    return typeof (base = this.props).tabChanged === "function" ? base.tabChanged({
      from: from,
      to: to,
      activeTabComponent: _(this._getActivePanel()).compact()[0]
    }) : void 0;
  },
  _getActivePanel: function() {
    return React.Children.map(this.props.children, (function(_this) {
      return function(child, idx) {
        if (idx === _this.state.active) {
          return React.cloneElement(child);
        }
      };
    })(this));
  },
  _getMenu: function() {
    return React.Children.map(this.props.children, (function(_this) {
      return function(child, idx) {
        var activeClass;
        child = React.cloneElement(child);
        if (idx === _this.state.active) {
          activeClass = 'active';
        }
        return React.createElement("li", {
          "className": activeClass
        }, React.createElement("a", {
          "href": '#',
          "onClick": _this._switchTab(idx)
        }, child.props.caption));
      };
    })(this));
  },
  componentDidMount: function() {
    return this._tabChanged(null, this.state.active);
  },
  componentDidUpdate: function(prevProps, prevState) {
    if (prevState.active !== this.state.active) {
      return this._tabChanged(prevState.active, this.state.active);
    }
  },
  render: function() {
    return React.createElement("div", {
      "className": 'tabpanel'
    }, React.createElement("div", {
      "className": "tab-headers"
    }, React.createElement("ul", {
      "className": 'presentation-nav presentation-nav-tabs',
      "role": 'tablist'
    }, this._getMenu())), this._getActivePanel());
  }
});

Tab = createReactClass({
  displayName: "Tab",
  propTypes: {
    caption: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element])
  },
  render: function() {
    return React.createElement("div", {
      "className": 'tab-content active'
    }, this.props.children);
  }
});

module.exports = {
  List: List,
  Tab: Tab
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, DetailedJustification, StaticHtmlContent, createReactClass;

StaticHtmlContent = __webpack_require__(3);

CustomRenderMixin = __webpack_require__(2);

createReactClass = __webpack_require__(0);

DetailedJustification = createReactClass({
  displayName: "DetailedJustification",
  mixins: [CustomRenderMixin],
  _getContent: function() {
    var ref, ref1;
    return (ref = this.props.conclusions) != null ? (ref1 = ref.getIn(['details', 'criteria'])) != null ? ref1.map((function(_this) {
      return function(value, key) {
        var name;
        name = _this.props.assessmentSections.getIn([key, 'name']);
        return "<p><span class='bold'>" + name + "</span>: " + value + "</p>";
      };
    })(this)).join("") : void 0 : void 0;
  },
  render: function() {
    var contentClasses, headerClasses, sectionName;
    sectionName = this.props.conclusions.getIn(['details', 'description']);
    contentClasses = classNames('detailed-content', {
      'clinicians': this.props.type === 'clinicians',
      'policymakers': this.props.type === 'policymakers'
    });
    headerClasses = classNames({
      'section-title': this.props.type === 'clinicians'
    });
    return React.createElement("div", {
      "className": "justification"
    }, React.createElement("h4", {
      "className": headerClasses
    }, sectionName), React.createElement("div", {
      "className": contentClasses
    }, React.createElement(StaticHtmlContent, {
      "content": this._getContent()
    })));
  }
});

module.exports = DetailedJustification;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var ISoFDx, ISoFTx, SummaryOfFindings, createReactClass;

ISoFDx = __webpack_require__(78);

ISoFTx = __webpack_require__(79);

createReactClass = __webpack_require__(0);

SummaryOfFindings = createReactClass({
  displayName: "SummaryOfFindings",
  getInitialState: function() {
    return {
      comparator: 'index'
    };
  },
  getDxIsofData: function() {
    if (this.props.isofData.comparatorIsofData != null) {
      if (this.state.comparator === 'index') {
        return this.props.isofData.indexIsofData;
      } else {
        return this.props.isofData.comparatorIsofData;
      }
    } else {
      return this.props.isofData;
    }
  },
  isDiagnostic: function() {
    if (this.props.isofData.comparatorIsofData != null) {
      return true;
    }
    return this.props.isofData.isDiagnostic;
  },
  onComparatorChange: function(e) {
    return this.setState({
      comparator: e.target.value
    });
  },
  componentDidMount: function() {
    if (this.isDiagnostic()) {
      $('#isof-dx-content').addClass('isof-dx container');
      return new ISoFDx('#isof-dx-content', this.getDxIsofData());
    } else {
      $('#isof-tx-content').addClass('isof-tx container');
      return new ISoFTx('#isof-tx-content', this.props.isofData, this.props.onSavePlainLanguageStatement);
    }
  },
  componentDidUpdate: function() {
    if (this.isDiagnostic()) {
      $('#isof-dx-content').addClass('isof-dx container');
      return new ISoFDx().rerender('#isof-dx-content', this.getDxIsofData());
    } else {
      $('#isof-tx-content').addClass('isof-tx container');
      return new ISoFTx().rerender('#isof-tx-content', this.props.isofData, this.props.onSavePlainLanguageStatement);
    }
  },
  render: function() {
    return React.createElement("div", {
      "className": "isof-tab"
    }, React.createElement("div", {
      "id": "isof-dx-content"
    }, (this.props.isofData.comparatorIsofData != null ? React.createElement("div", null, React.createElement("select", {
      "className": "test-dropdown",
      "onChange": this.onComparatorChange
    }, React.createElement("option", {
      "value": "index"
    }, "Index test: ", this.props.isofData.indexIsofData.test), React.createElement("option", {
      "value": "comparator"
    }, "Comparator test: ", this.props.isofData.comparatorIsofData.test)), React.createElement("br", null), React.createElement("br", null)) : void 0), React.createElement("diagnosis", null)), React.createElement("div", {
      "id": "isof-tx-content"
    }, React.createElement("isof-table", {
      "editable": "false"
    })));
  }
});

module.exports = SummaryOfFindings;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(88);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(23),
    root = __webpack_require__(7);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(25),
    eq = __webpack_require__(14);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(23);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(139);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(140),
    isObjectLike = __webpack_require__(8);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(7),
    stubFalse = __webpack_require__(142);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)(module)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(144),
    baseUnary = __webpack_require__(145),
    nodeUtil = __webpack_require__(146);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(150),
    baseKeysIn = __webpack_require__(152),
    isArrayLike = __webpack_require__(27);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var SectionIcon, SectionWithIcon, node, ref, string;

SectionIcon = __webpack_require__(169);

ref = __webpack_require__(1), string = ref.string, node = ref.node;

SectionWithIcon = function(arg) {
  var children, className, icon, title;
  title = arg.title, icon = arg.icon, children = arg.children, className = arg.className;
  return React.createElement("div", {
    "className": classNames("section", className)
  }, React.createElement("div", {
    "className": "section__header"
  }, React.createElement(SectionIcon, {
    "icon": icon
  }), React.createElement("h2", null, title)), children);
};

SectionWithIcon.propTypes = {
  icon: string.isRequired,
  title: string,
  className: string,
  children: node.isRequired
};

SectionWithIcon.defaultProps = {
  className: '',
  title: ''
};

module.exports = SectionWithIcon;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Clinicians, LngContext, Patients, Policymakers, PremiumPresentationForPatients, Presentations, RecommendationHeader, TRANSLATION_FILES, Translation, addTranslationResources, arrayOf, bool, createReactClass, func, instanceOf, kebabCase, merge, number, object, oneOf, oneOfType, ref, shape, string, translationsAr, translationsCs, translationsDe, translationsEn, translationsEs, translationsFa, translationsFr, translationsHi, translationsIt, translationsPt, translationsSk, translationsZhChs;

Clinicians = __webpack_require__(53);

createReactClass = __webpack_require__(0);

kebabCase = __webpack_require__(82);

merge = __webpack_require__(98);

Patients = __webpack_require__(163);

Policymakers = __webpack_require__(164);

PremiumPresentationForPatients = __webpack_require__(165);

RecommendationHeader = __webpack_require__(172);

Translation = __webpack_require__(4);

translationsAr = __webpack_require__(173);

translationsCs = __webpack_require__(174);

translationsDe = __webpack_require__(175);

translationsEn = __webpack_require__(176);

translationsEs = __webpack_require__(177);

translationsFa = __webpack_require__(178);

translationsFr = __webpack_require__(179);

translationsHi = __webpack_require__(180);

translationsIt = __webpack_require__(181);

translationsPt = __webpack_require__(182);

translationsSk = __webpack_require__(183);

translationsZhChs = __webpack_require__(184);

__webpack_require__(185);

__webpack_require__(186);

LngContext = __webpack_require__(9);

ref = __webpack_require__(1), string = ref.string, func = ref.func, bool = ref.bool, instanceOf = ref.instanceOf, object = ref.object, number = ref.number, arrayOf = ref.arrayOf, shape = ref.shape, oneOfType = ref.oneOfType, oneOf = ref.oneOf;

TRANSLATION_FILES = {
  'ar': translationsAr,
  'cs': translationsCs,
  'de': translationsDe,
  'en': translationsEn,
  'es': translationsEs,
  'fa': translationsFa,
  'fr': translationsFr,
  'hi': translationsHi,
  'it': translationsIt,
  'pt': translationsPt,
  'sk': translationsSk,
  'zh_CHS': translationsZhChs
};

addTranslationResources = function(language, overwrites) {
  if (overwrites == null) {
    overwrites = {};
  }
  if (i18next.language != null) {
    return _.each(TRANSLATION_FILES, function(file, key) {
      return i18next.addResourceBundle(key, 'presentations', merge({}, file, overwrites[key] || {}));
    });
  } else {
    i18nextJquery.init(i18next, $, {
      tName: 't',
      i18nName: 'i18n'
    });
    return i18next.use(i18nextXHRBackend).init({
      lng: language,
      fallbackLng: 'en',
      compatibilityAPI: 'v1',
      compatibilityJSON: 'v1',
      resources: {
        ar: {
          presentations: translationsAr
        },
        cs: {
          presentations: translationsCs
        },
        de: {
          presentations: translationsDe
        },
        en: {
          presentations: translationsEn
        },
        es: {
          presentations: translationsEs
        },
        fa: {
          presentations: translationsFa
        },
        fr: {
          presentations: translationsFr
        },
        hi: {
          presentations: translationsHi
        },
        it: {
          presentations: translationsIt
        },
        pt: {
          presentations: translationsPt
        },
        sk: {
          presentations: translationsSk
        },
        zh_CHS: {
          presentations: translationsZhChs
        }
      },
      ns: {
        namespaces: ['presentations'],
        defaultNs: "presentations"
      }
    });
  }
};

Presentations = createReactClass({
  displayName: "PresentationsComponent",
  propTypes: {
    actions: object,
    assessment: instanceOf(Immutable.Map).isRequired,
    attachments: instanceOf(Immutable.Map),
    backgroundDetailSections: instanceOf(Immutable.OrderedMap).isRequired,
    clinicians: instanceOf(Immutable.OrderedMap).isRequired,
    conclusions: instanceOf(Immutable.OrderedMap).isRequired,
    currentEditable: string,
    displayContext: oneOf(['default', 'DBEP']),
    documentType: oneOf(['regular', 'gps', 'additional-guidance']),
    isEditable: bool.isRequired,
    isofData: object,
    isIsofVisibleInPremiumView: bool,
    toggleSofTableInPremiumView: func.isRequired,
    showSof: bool,
    showRecommendationHeader: bool,
    patients: instanceOf(Immutable.Map).isRequired,
    policymakers: instanceOf(Immutable.Map).isRequired,
    presentationData: instanceOf(Immutable.Map).isRequired,
    presentationTitle: string,
    presentationType: string.isRequired,
    sectionTabs: arrayOf(string),
    question: instanceOf(Immutable.Map).isRequired,
    questionData: instanceOf(Immutable.Map),
    recommendation: shape({
      content: oneOfType([instanceOf(Immutable.Map), string]).isRequired,
      selectedOption: string,
      references: instanceOf(Immutable.Map)
    }),
    references: instanceOf(Immutable.List),
    relatedQuestions: instanceOf(Immutable.Map),
    relatedRecommendations: instanceOf(Immutable.Map),
    theme: oneOf(['default', 'dbep']),
    publicationDate: number,
    language: string,
    translations: object
  },
  getDefaultProps: function() {
    return {
      actions: {},
      displayContext: 'default',
      documentType: 'regular',
      isIsofVisibleInPremiumView: false,
      language: 'en',
      presentationTitle: '',
      publicationDate: null,
      questionData: Immutable.Map(),
      references: Immutable.List(),
      relatedQuestions: Immutable.Map(),
      relatedRecommendations: Immutable.Map(),
      sectionTabs: null,
      showRecommendationHeader: true,
      showSof: true,
      theme: 'default',
      translations: {}
    };
  },
  mixins: [Translation('')],
  componentWillMount: function() {
    var language, ref1, translations;
    ref1 = this.props, language = ref1.language, translations = ref1.translations;
    return addTranslationResources(language, translations);
  },
  getRecommendationContent: function() {
    var customRecommendation, presentationData, presentationType, recommendation, ref1, ref2;
    ref1 = this.props, presentationData = ref1.presentationData, presentationType = ref1.presentationType, recommendation = ref1.recommendation;
    presentationType = presentationType === 'premium-patients' ? 'patients' : presentationType;
    customRecommendation = presentationData.getIn([presentationType, 'sections', 'recommendation', 'content']);
    return (ref2 = customRecommendation != null ? customRecommendation : recommendation.content) != null ? ref2 : "";
  },
  render: function() {
    var comparison, containerClasses, documentType, intervention, presentationType, questionData, recommendationContent, ref1, ref2, ref3, selectedOption, theme;
    ref1 = this.props, presentationType = ref1.presentationType, questionData = ref1.questionData, theme = ref1.theme, documentType = ref1.documentType;
    selectedOption = this.props.recommendation.selectedOption;
    recommendationContent = this.getRecommendationContent();
    containerClasses = classNames('presentations-container', theme, kebabCase(selectedOption));
    if (presentationType === 'premium-patients') {
      intervention = (ref2 = questionData.get('intervention')) != null ? ref2 : "";
      comparison = (ref3 = questionData.get('comparison')) != null ? ref3 : "";
      return React.createElement(LngContext.Provider, {
        "value": this.props.language
      }, React.createElement("div", {
        "id": "presentations",
        "className": containerClasses
      }, React.createElement(PremiumPresentationForPatients, {
        "comparison": comparison,
        "documentType": documentType,
        "i18n": this.i18n,
        "intervention": intervention,
        "isIsofVisibleInPremiumView": this.props.isIsofVisibleInPremiumView,
        "isofData": this.props.isofData,
        "presentationName": this.props.presentationData.getIn(['patients', 'presentationName']),
        "publicationDate": this.props.publicationDate,
        "recommendation": selectedOption,
        "recommendationContent": recommendationContent,
        "references": this.props.references,
        "sections": this.props.patients,
        "theme": this.props.premiumTheme,
        "toggleSofTableInPremiumView": this.props.toggleSofTableInPremiumView
      })));
    } else {
      return React.createElement(LngContext.Provider, {
        "value": this.props.language
      }, React.createElement("div", {
        "id": "presentations",
        "className": containerClasses
      }, React.createElement(RecommendationHeader, {
        "actions": this.props.actions,
        "content": recommendationContent,
        "currentEditable": this.props.currentEditable,
        "displayContext": this.props.displayContext,
        "isEditable": this.props.isEditable,
        "presentationData": this.props.presentationData,
        "presentationName": this.props.presentationData.getIn([presentationType, 'presentationName']),
        "presentationTitle": this.props.presentationTitle,
        "presentationType": presentationType,
        "references": this.props.references,
        "selectedOption": selectedOption,
        "showRecommendationHeader": this.props.showRecommendationHeader
      }), React.createElement("div", {
        "className": "presentation-content"
      }, (presentationType === 'policymakers' ? React.createElement(Policymakers, {
        "actions": this.props.actions,
        "assessment": this.props.assessment,
        "assessmentSections": this.props.assessment.get('sections', Immutable.Map()),
        "attachments": this.props.attachments,
        "backgroundDetailSections": this.props.backgroundDetailSections,
        "conclusions": this.props.conclusions,
        "currentEditable": this.props.currentEditable,
        "isEditable": this.props.isEditable,
        "isofData": this.props.isofData,
        "presentationData": this.props.presentationData.get('policymakers'),
        "question": this.props.question,
        "questionData": this.props.questionData,
        "references": this.props.references,
        "relatedQuestions": this.props.relatedQuestions,
        "relatedRecommendations": this.props.relatedRecommendations,
        "sections": this.props.policymakers,
        "sectionTabs": this.props.sectionTabs,
        "showSof": this.props.showSof
      }) : void 0), (presentationType === 'clinicians' ? React.createElement(Clinicians, {
        "actions": this.props.actions,
        "assessmentSections": this.props.assessment.get('sections', Immutable.Map()),
        "attachments": this.props.attachments,
        "conclusions": this.props.conclusions,
        "currentEditable": this.props.currentEditable,
        "isEditable": this.props.isEditable,
        "isofData": this.props.isofData,
        "onSavePlainLanguageStatement": this.props.onSavePlainLanguageStatement,
        "presentationData": this.props.presentationData.get('clinicians'),
        "question": this.props.question,
        "references": this.props.references,
        "relatedQuestions": this.props.relatedQuestions,
        "relatedRecommendations": this.props.relatedRecommendations,
        "sections": this.props.clinicians,
        "sectionTabs": this.props.sectionTabs,
        "showSof": this.props.showSof
      }) : void 0), (presentationType === 'patients' ? React.createElement(Patients, {
        "actions": this.props.actions,
        "assessmentSections": this.props.assessment.get('sections', Immutable.Map()),
        "attachments": this.props.attachments,
        "conclusions": this.props.conclusions,
        "currentEditable": this.props.currentEditable,
        "isEditable": this.props.isEditable,
        "isofData": this.props.isofData,
        "presentationData": this.props.presentationData.get('patients'),
        "presentations": this.props.presentations,
        "references": this.props.references,
        "relatedQuestions": this.props.relatedQuestions,
        "relatedRecommendations": this.props.relatedRecommendations,
        "sections": this.props.patients,
        "sectionTabs": this.props.sectionTabs,
        "showSof": this.props.showSof
      }) : void 0))));
    }
  }
});

module.exports = Presentations;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var Clinicians, SectionTabs, createReactClass;

SectionTabs = __webpack_require__(17);

createReactClass = __webpack_require__(0);

Clinicians = createReactClass({
  displayName: "Clinicians",
  render: function() {
    return React.createElement(SectionTabs, {
      "actions": this.props.actions,
      "assessmentSections": this.props.assessmentSections,
      "conclusions": this.props.conclusions,
      "currentEditable": this.props.currentEditable,
      "isEditable": this.props.isEditable,
      "isofData": this.props.isofData,
      "onSavePlainLanguageStatement": this.props.onSavePlainLanguageStatement,
      "presentationData": this.props.presentationData,
      "question": this.props.question,
      "references": this.props.references,
      "relatedQuestions": this.props.relatedQuestions,
      "relatedRecommendations": this.props.relatedRecommendations,
      "sections": this.props.sections,
      "sectionTabs": this.props.sectionTabs,
      "showSof": this.props.showSof,
      "type": "clinicians"
    });
  }
});

module.exports = Clinicians;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Assessment, CollapsiblePanel, CustomRenderMixin, PropTypes, Subgroup, createReactClass;

CollapsiblePanel = __webpack_require__(29);

CustomRenderMixin = __webpack_require__(2);

Subgroup = __webpack_require__(59);

createReactClass = __webpack_require__(0);

PropTypes = __webpack_require__(1);

Assessment = createReactClass({
  displayName: "Assessment",
  propTypes: {
    assessment: PropTypes.instanceOf(Immutable.Map).isRequired,
    sections: PropTypes.instanceOf(Immutable.Map).isRequired
  },
  mixins: [CustomRenderMixin],
  render: function() {
    var actions, assessment, attachments, currentEditable, isEditable, ref, references, sections;
    ref = this.props, actions = ref.actions, attachments = ref.attachments, currentEditable = ref.currentEditable, isEditable = ref.isEditable, references = ref.references, assessment = ref.assessment;
    sections = assessment.get('sections', Immutable.Map());
    return React.createElement("div", {
      "className": "assessment"
    }, sections.map((function(_this) {
      return function(section, index) {
        return React.createElement(CollapsiblePanel, {
          "key": section.get('name'),
          "title": section.get('name'),
          "className": "panel-toggle block",
          "collapsed": true
        }, React.createElement("div", {
          "className": "description"
        }, assessment.getIn(['criteria', index, 'description'], '')), React.createElement("div", null, React.createElement(Subgroup, {
          "actions": actions,
          "additionalConsiderations": assessment.getIn(['additionalConsiderations', index], Immutable.Map()),
          "attachments": attachments,
          "criteria": assessment.getIn(['criteria', index], Immutable.Map()),
          "currentEditable": currentEditable,
          "index": index,
          "isEditable": isEditable,
          "references": references,
          "researchEvidences": assessment.getIn(['researchEvidences', index], Immutable.Map())
        })));
      };
    })(this)).toList());
  }
});

module.exports = Assessment;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (process.env.NODE_ENV === 'production') {
  module.exports = __webpack_require__(56);
} else {
  module.exports = __webpack_require__(57);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(11),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/** @license React v16.14.0
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

var _assign = __webpack_require__(11);
var checkPropTypes = __webpack_require__(30);

var ReactVersion = '16.14.0';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

/**
 * Keeps track of the current dispatcher.
 */
var ReactCurrentDispatcher = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

/**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */
var ReactCurrentBatchConfig = {
  suspense: null
};

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
function describeComponentFrame (name, source, ownerName) {
  var sourceInfo = '';

  if (source) {
    var path = source.fileName;
    var fileName = path.replace(BEFORE_SLASH_RE, '');

    {
      // In DEV, include code for a common special case:
      // prefer "folder/index.js" instead of just "index.js".
      if (/^index\./.test(fileName)) {
        var match = path.match(BEFORE_SLASH_RE);

        if (match) {
          var pathBeforeSlash = match[1];

          if (pathBeforeSlash) {
            var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
            fileName = folderName + '/' + fileName;
          }
        }
      }
    }

    sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
  } else if (ownerName) {
    sourceInfo = ' (created by ' + ownerName + ')';
  }

  return '\n    in ' + (name || 'Unknown') + sourceInfo;
}

var Resolved = 1;
function refineResolvedLazyComponent(lazyComponent) {
  return lazyComponent._status === Resolved ? lazyComponent._result : null;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case REACT_FRAGMENT_TYPE:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return "Profiler";

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        return 'Context.Consumer';

      case REACT_PROVIDER_TYPE:
        return 'Context.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type.render);

      case REACT_LAZY_TYPE:
        {
          var thenable = type;
          var resolvedThenable = refineResolvedLazyComponent(thenable);

          if (resolvedThenable) {
            return getComponentName(resolvedThenable);
          }

          break;
        }
    }
  }

  return null;
}

var ReactDebugCurrentFrame = {};
var currentlyValidatingElement = null;
function setCurrentlyValidatingElement(element) {
  {
    currentlyValidatingElement = element;
  }
}

{
  // Stack implementation injected by the current renderer.
  ReactDebugCurrentFrame.getCurrentStack = null;

  ReactDebugCurrentFrame.getStackAddendum = function () {
    var stack = ''; // Add an extra top frame while an element is being validated

    if (currentlyValidatingElement) {
      var name = getComponentName(currentlyValidatingElement.type);
      var owner = currentlyValidatingElement._owner;
      stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner.type));
    } // Delegate to the injected renderer-specific implementation


    var impl = ReactDebugCurrentFrame.getCurrentStack;

    if (impl) {
      stack += impl() || '';
    }

    return stack;
  };
}

/**
 * Used by act() to track whether you're inside an act() scope.
 */
var IsSomeRendererActing = {
  current: false
};

var ReactSharedInternals = {
  ReactCurrentDispatcher: ReactCurrentDispatcher,
  ReactCurrentBatchConfig: ReactCurrentBatchConfig,
  ReactCurrentOwner: ReactCurrentOwner,
  IsSomeRendererActing: IsSomeRendererActing,
  // Used by renderers to avoid bundling object-assign twice in UMD bundles:
  assign: _assign
};

{
  _assign(ReactSharedInternals, {
    // These should not be included in production.
    ReactDebugCurrentFrame: ReactDebugCurrentFrame,
    // Shim for React DOM 16.0.0 which still destructured (but not used) this.
    // TODO: remove in React 17.0.
    ReactComponentTreeHook: {}
  });
}

// by calls to these methods by a Babel plugin.
//
// In PROD (or in packages without access to React internals),
// they are left as they are instead.

function warn(format) {
  {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    printWarning('warn', format, args);
  }
}
function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === 'string' && args[args.length - 1].indexOf('\n    in') === 0;

    if (!hasExistingStack) {
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      var stack = ReactDebugCurrentFrame.getStackAddendum();

      if (stack !== '') {
        format += '%s';
        args = args.concat([stack]);
      }
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      throw new Error(message);
    } catch (x) {}
  }
}

var didWarnStateUpdateForUnmountedComponent = {};

function warnNoop(publicInstance, callerName) {
  {
    var _constructor = publicInstance.constructor;
    var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
    var warningKey = componentName + "." + callerName;

    if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
      return;
    }

    error("Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);

    didWarnStateUpdateForUnmountedComponent[warningKey] = true;
  }
}
/**
 * This is the abstract API for an update queue.
 */


var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance, callback, callerName) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState, callback, callerName) {
    warnNoop(publicInstance, 'setState');
  }
};

var emptyObject = {};

{
  Object.freeze(emptyObject);
}
/**
 * Base class helpers for the updating state of a component.
 */


function Component(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
  // renderer.

  this.updater = updater || ReactNoopUpdateQueue;
}

Component.prototype.isReactComponent = {};
/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */

Component.prototype.setState = function (partialState, callback) {
  if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) {
    {
      throw Error( "setState(...): takes an object of state variables to update or a function which returns an object of state variables." );
    }
  }

  this.updater.enqueueSetState(this, partialState, callback, 'setState');
};
/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */


Component.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
};
/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */


{
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };

  var defineDeprecationWarning = function (methodName, info) {
    Object.defineProperty(Component.prototype, methodName, {
      get: function () {
        warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);

        return undefined;
      }
    });
  };

  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

function ComponentDummy() {}

ComponentDummy.prototype = Component.prototype;
/**
 * Convenience component with default shallow equality check for sCU.
 */

function PureComponent(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject;
  this.updater = updater || ReactNoopUpdateQueue;
}

var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.

_assign(pureComponentPrototype, Component.prototype);

pureComponentPrototype.isPureReactComponent = true;

// an immutable object with a single mutable value
function createRef() {
  var refObject = {
    current: null
  };

  {
    Object.seal(refObject);
  }

  return refObject;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
      }
    }
  };

  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
      }
    }
  };

  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

function warnIfStringRefCannotBeAutoConverted(config) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://fb.me/react-strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */

function createElement(type, config, children) {
  var propName; // Reserved names are extracted

  var props = {};
  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;

      {
        warnIfStringRefCannotBeAutoConverted(config);
      }
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }

    props.children = childArray;
  } // Resolve default props


  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;

    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }

  {
    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }
  }

  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
}
function cloneAndReplaceKey(oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
  return newElement;
}
/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */

function cloneElement(element, config, children) {
  if (!!(element === null || element === undefined)) {
    {
      throw Error( "React.cloneElement(...): The argument must be a React element, but you passed " + element + "." );
    }
  }

  var propName; // Original props are copied

  var props = _assign({}, element.props); // Reserved names are extracted


  var key = element.key;
  var ref = element.ref; // Self is preserved since the owner is preserved.

  var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.

  var source = element._source; // Owner will be preserved, unless ref is overridden

  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    } // Remaining properties override existing props


    var defaultProps;

    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}

var SEPARATOR = '.';
var SUBSEPARATOR = ':';
/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });
  return '$' + escapedString;
}
/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */


var didWarnAboutMaps = false;
var userProvidedKeyEscapeRegex = /\/+/g;

function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

var POOL_SIZE = 10;
var traverseContextPool = [];

function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
  if (traverseContextPool.length) {
    var traverseContext = traverseContextPool.pop();
    traverseContext.result = mapResult;
    traverseContext.keyPrefix = keyPrefix;
    traverseContext.func = mapFunction;
    traverseContext.context = mapContext;
    traverseContext.count = 0;
    return traverseContext;
  } else {
    return {
      result: mapResult,
      keyPrefix: keyPrefix,
      func: mapFunction,
      context: mapContext,
      count: 0
    };
  }
}

function releaseTraverseContext(traverseContext) {
  traverseContext.result = null;
  traverseContext.keyPrefix = null;
  traverseContext.func = null;
  traverseContext.context = null;
  traverseContext.count = 0;

  if (traverseContextPool.length < POOL_SIZE) {
    traverseContextPool.push(traverseContext);
  }
}
/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */


function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  var invokeCallback = false;

  if (children === null) {
    invokeCallback = true;
  } else {
    switch (type) {
      case 'string':
      case 'number':
        invokeCallback = true;
        break;

      case 'object':
        switch (children.$$typeof) {
          case REACT_ELEMENT_TYPE:
          case REACT_PORTAL_TYPE:
            invokeCallback = true;
        }

    }
  }

  if (invokeCallback) {
    callback(traverseContext, children, // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.

  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);

    if (typeof iteratorFn === 'function') {

      {
        // Warn about using Maps as children
        if (iteratorFn === children.entries) {
          if (!didWarnAboutMaps) {
            warn('Using Maps as children is deprecated and will be removed in ' + 'a future major release. Consider converting children to ' + 'an array of keyed ReactElements instead.');
          }

          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(children);
      var step;
      var ii = 0;

      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getComponentKey(child, ii++);
        subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
      }
    } else if (type === 'object') {
      var addendum = '';

      {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + ReactDebugCurrentFrame.getStackAddendum();
      }

      var childrenString = '' + children;

      {
        {
          throw Error( "Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + ")." + addendum );
        }
      }
    }
  }

  return subtreeCount;
}
/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */


function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}
/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */


function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (typeof component === 'object' && component !== null && component.key != null) {
    // Explicit key
    return escape(component.key);
  } // Implicit key determined by the index in the set


  return index.toString(36);
}

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;
  func.call(context, child, bookKeeping.count++);
}
/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */


function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }

  var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  releaseTraverseContext(traverseContext);
}

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;
  var mappedChild = func.call(context, child, bookKeeping.count++);

  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, function (c) {
      return c;
    });
  } else if (mappedChild != null) {
    if (isValidElement(mappedChild)) {
      mappedChild = cloneAndReplaceKey(mappedChild, // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }

    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';

  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }

  var traverseContext = getPooledTraverseContext(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  releaseTraverseContext(traverseContext);
}
/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */


function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }

  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}
/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */


function countChildren(children) {
  return traverseAllChildren(children, function () {
    return null;
  }, null);
}
/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */


function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, function (child) {
    return child;
  });
  return result;
}
/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */


function onlyChild(children) {
  if (!isValidElement(children)) {
    {
      throw Error( "React.Children.only expected to receive a single React element child." );
    }
  }

  return children;
}

function createContext(defaultValue, calculateChangedBits) {
  if (calculateChangedBits === undefined) {
    calculateChangedBits = null;
  } else {
    {
      if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') {
        error('createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits);
      }
    }
  }

  var context = {
    $$typeof: REACT_CONTEXT_TYPE,
    _calculateChangedBits: calculateChangedBits,
    // As a workaround to support multiple concurrent renderers, we categorize
    // some renderers as primary and others as secondary. We only expect
    // there to be two concurrent renderers at most: React Native (primary) and
    // Fabric (secondary); React DOM (primary) and React ART (secondary).
    // Secondary renderers store their context values on separate fields.
    _currentValue: defaultValue,
    _currentValue2: defaultValue,
    // Used to track how many concurrent renderers this context currently
    // supports within in a single renderer. Such as parallel server rendering.
    _threadCount: 0,
    // These are circular
    Provider: null,
    Consumer: null
  };
  context.Provider = {
    $$typeof: REACT_PROVIDER_TYPE,
    _context: context
  };
  var hasWarnedAboutUsingNestedContextConsumers = false;
  var hasWarnedAboutUsingConsumerProvider = false;

  {
    // A separate object, but proxies back to the original context object for
    // backwards compatibility. It has a different $$typeof, so we can properly
    // warn for the incorrect usage of Context as a Consumer.
    var Consumer = {
      $$typeof: REACT_CONTEXT_TYPE,
      _context: context,
      _calculateChangedBits: context._calculateChangedBits
    }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here

    Object.defineProperties(Consumer, {
      Provider: {
        get: function () {
          if (!hasWarnedAboutUsingConsumerProvider) {
            hasWarnedAboutUsingConsumerProvider = true;

            error('Rendering <Context.Consumer.Provider> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Provider> instead?');
          }

          return context.Provider;
        },
        set: function (_Provider) {
          context.Provider = _Provider;
        }
      },
      _currentValue: {
        get: function () {
          return context._currentValue;
        },
        set: function (_currentValue) {
          context._currentValue = _currentValue;
        }
      },
      _currentValue2: {
        get: function () {
          return context._currentValue2;
        },
        set: function (_currentValue2) {
          context._currentValue2 = _currentValue2;
        }
      },
      _threadCount: {
        get: function () {
          return context._threadCount;
        },
        set: function (_threadCount) {
          context._threadCount = _threadCount;
        }
      },
      Consumer: {
        get: function () {
          if (!hasWarnedAboutUsingNestedContextConsumers) {
            hasWarnedAboutUsingNestedContextConsumers = true;

            error('Rendering <Context.Consumer.Consumer> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
          }

          return context.Consumer;
        }
      }
    }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty

    context.Consumer = Consumer;
  }

  {
    context._currentRenderer = null;
    context._currentRenderer2 = null;
  }

  return context;
}

function lazy(ctor) {
  var lazyType = {
    $$typeof: REACT_LAZY_TYPE,
    _ctor: ctor,
    // React uses these fields to store the result.
    _status: -1,
    _result: null
  };

  {
    // In production, this would just set it on the object.
    var defaultProps;
    var propTypes;
    Object.defineProperties(lazyType, {
      defaultProps: {
        configurable: true,
        get: function () {
          return defaultProps;
        },
        set: function (newDefaultProps) {
          error('React.lazy(...): It is not supported to assign `defaultProps` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          defaultProps = newDefaultProps; // Match production behavior more closely:

          Object.defineProperty(lazyType, 'defaultProps', {
            enumerable: true
          });
        }
      },
      propTypes: {
        configurable: true,
        get: function () {
          return propTypes;
        },
        set: function (newPropTypes) {
          error('React.lazy(...): It is not supported to assign `propTypes` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          propTypes = newPropTypes; // Match production behavior more closely:

          Object.defineProperty(lazyType, 'propTypes', {
            enumerable: true
          });
        }
      }
    });
  }

  return lazyType;
}

function forwardRef(render) {
  {
    if (render != null && render.$$typeof === REACT_MEMO_TYPE) {
      error('forwardRef requires a render function but received a `memo` ' + 'component. Instead of forwardRef(memo(...)), use ' + 'memo(forwardRef(...)).');
    } else if (typeof render !== 'function') {
      error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
    } else {
      if (render.length !== 0 && render.length !== 2) {
        error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
      }
    }

    if (render != null) {
      if (render.defaultProps != null || render.propTypes != null) {
        error('forwardRef render functions do not support propTypes or defaultProps. ' + 'Did you accidentally pass a React component?');
      }
    }
  }

  return {
    $$typeof: REACT_FORWARD_REF_TYPE,
    render: render
  };
}

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function memo(type, compare) {
  {
    if (!isValidElementType(type)) {
      error('memo: The first argument must be a component. Instead ' + 'received: %s', type === null ? 'null' : typeof type);
    }
  }

  return {
    $$typeof: REACT_MEMO_TYPE,
    type: type,
    compare: compare === undefined ? null : compare
  };
}

function resolveDispatcher() {
  var dispatcher = ReactCurrentDispatcher.current;

  if (!(dispatcher !== null)) {
    {
      throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem." );
    }
  }

  return dispatcher;
}

function useContext(Context, unstable_observedBits) {
  var dispatcher = resolveDispatcher();

  {
    if (unstable_observedBits !== undefined) {
      error('useContext() second argument is reserved for future ' + 'use in React. Passing it is not supported. ' + 'You passed: %s.%s', unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? '\n\nDid you call array.map(useContext)? ' + 'Calling Hooks inside a loop is not supported. ' + 'Learn more at https://fb.me/rules-of-hooks' : '');
    } // TODO: add a more generic warning for invalid values.


    if (Context._context !== undefined) {
      var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
      // and nobody should be using this in existing code.

      if (realContext.Consumer === Context) {
        error('Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be ' + 'removed in a future major release. Did you mean to call useContext(Context) instead?');
      } else if (realContext.Provider === Context) {
        error('Calling useContext(Context.Provider) is not supported. ' + 'Did you mean to call useContext(Context) instead?');
      }
    }
  }

  return dispatcher.useContext(Context, unstable_observedBits);
}
function useState(initialState) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useState(initialState);
}
function useReducer(reducer, initialArg, init) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useReducer(reducer, initialArg, init);
}
function useRef(initialValue) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useRef(initialValue);
}
function useEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useEffect(create, deps);
}
function useLayoutEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useLayoutEffect(create, deps);
}
function useCallback(callback, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useCallback(callback, deps);
}
function useMemo(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useMemo(create, deps);
}
function useImperativeHandle(ref, create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useImperativeHandle(ref, create, deps);
}
function useDebugValue(value, formatterFn) {
  {
    var dispatcher = resolveDispatcher();
    return dispatcher.useDebugValue(value, formatterFn);
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = getComponentName(ReactCurrentOwner.current.type);

    if (name) {
      return '\n\nCheck the render method of `' + name + '`.';
    }
  }

  return '';
}

function getSourceInfoErrorAddendum(source) {
  if (source !== undefined) {
    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
    var lineNumber = source.lineNumber;
    return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
  }

  return '';
}

function getSourceInfoErrorAddendumForProps(elementProps) {
  if (elementProps !== null && elementProps !== undefined) {
    return getSourceInfoErrorAddendum(elementProps.__source);
  }

  return '';
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  var info = getDeclarationErrorAddendum();

  if (!info) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

    if (parentName) {
      info = "\n\nCheck the top-level render call using <" + parentName + ">.";
    }
  }

  return info;
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }

  element._store.validated = true;
  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

  if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
    return;
  }

  ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.

  var childOwner = '';

  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
  }

  setCurrentlyValidatingElement(element);

  {
    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.', currentComponentErrorInfo, childOwner);
  }

  setCurrentlyValidatingElement(null);
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }

  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];

      if (isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);

    if (typeof iteratorFn === 'function') {
      // Entry iterators used to provide implicit keys,
      // but now we print a separate warning for them later.
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step;

        while (!(step = iterator.next()).done) {
          if (isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var name = getComponentName(type);
    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      setCurrentlyValidatingElement(element);
      checkPropTypes(propTypes, element.props, 'prop', name, ReactDebugCurrentFrame.getStackAddendum);
      setCurrentlyValidatingElement(null);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true;

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    setCurrentlyValidatingElement(fragment);
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        break;
      }
    }

    if (fragment.ref !== null) {
      error('Invalid attribute `ref` supplied to `React.Fragment`.');
    }

    setCurrentlyValidatingElement(null);
  }
}
function createElementWithValidation(type, props, children) {
  var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
  // succeed and there will likely be errors in render.

  if (!validType) {
    var info = '';

    if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
      info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
    }

    var sourceInfo = getSourceInfoErrorAddendumForProps(props);

    if (sourceInfo) {
      info += sourceInfo;
    } else {
      info += getDeclarationErrorAddendum();
    }

    var typeString;

    if (type === null) {
      typeString = 'null';
    } else if (Array.isArray(type)) {
      typeString = 'array';
    } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
      typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
      info = ' Did you accidentally export a JSX literal instead of a component?';
    } else {
      typeString = typeof type;
    }

    {
      error('React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }
  }

  var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
  // TODO: Drop this when these are no longer allowed as the type argument.

  if (element == null) {
    return element;
  } // Skip key warning if the type isn't valid since our key validation logic
  // doesn't expect a non-string/function type and can throw confusing errors.
  // We don't want exception behavior to differ between dev and prod.
  // (Rendering will throw with a helpful message and as soon as the type is
  // fixed, the key warnings will appear.)


  if (validType) {
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], type);
    }
  }

  if (type === REACT_FRAGMENT_TYPE) {
    validateFragmentProps(element);
  } else {
    validatePropTypes(element);
  }

  return element;
}
var didWarnAboutDeprecatedCreateFactory = false;
function createFactoryWithValidation(type) {
  var validatedFactory = createElementWithValidation.bind(null, type);
  validatedFactory.type = type;

  {
    if (!didWarnAboutDeprecatedCreateFactory) {
      didWarnAboutDeprecatedCreateFactory = true;

      warn('React.createFactory() is deprecated and will be removed in ' + 'a future major release. Consider using JSX ' + 'or use React.createElement() directly instead.');
    } // Legacy hook: remove it


    Object.defineProperty(validatedFactory, 'type', {
      enumerable: false,
      get: function () {
        warn('Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');

        Object.defineProperty(this, 'type', {
          value: type
        });
        return type;
      }
    });
  }

  return validatedFactory;
}
function cloneElementWithValidation(element, props, children) {
  var newElement = cloneElement.apply(this, arguments);

  for (var i = 2; i < arguments.length; i++) {
    validateChildKeys(arguments[i], newElement.type);
  }

  validatePropTypes(newElement);
  return newElement;
}

{

  try {
    var frozenObject = Object.freeze({});
    var testMap = new Map([[frozenObject, null]]);
    var testSet = new Set([frozenObject]); // This is necessary for Rollup to not consider these unused.
    // https://github.com/rollup/rollup/issues/1771
    // TODO: we can remove these if Rollup fixes the bug.

    testMap.set(0, 0);
    testSet.add(0);
  } catch (e) {
  }
}

var createElement$1 =  createElementWithValidation ;
var cloneElement$1 =  cloneElementWithValidation ;
var createFactory =  createFactoryWithValidation ;
var Children = {
  map: mapChildren,
  forEach: forEachChildren,
  count: countChildren,
  toArray: toArray,
  only: onlyChild
};

exports.Children = Children;
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
exports.cloneElement = cloneElement$1;
exports.createContext = createContext;
exports.createElement = createElement$1;
exports.createFactory = createFactory;
exports.createRef = createRef;
exports.forwardRef = forwardRef;
exports.isValidElement = isValidElement;
exports.lazy = lazy;
exports.memo = memo;
exports.useCallback = useCallback;
exports.useContext = useContext;
exports.useDebugValue = useDebugValue;
exports.useEffect = useEffect;
exports.useImperativeHandle = useImperativeHandle;
exports.useLayoutEffect = useLayoutEffect;
exports.useMemo = useMemo;
exports.useReducer = useReducer;
exports.useRef = useRef;
exports.useState = useState;
exports.version = ReactVersion;
  })();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(11);

// -- Inlined from fbjs --

var emptyObject = {};

if (process.env.NODE_ENV !== 'production') {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (process.env.NODE_ENV !== 'production') {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (process.env.NODE_ENV !== 'production') {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (process.env.NODE_ENV !== 'production') {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (process.env.NODE_ENV !== 'production') {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (process.env.NODE_ENV !== 'production') {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (process.env.NODE_ENV !== 'production') {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (process.env.NODE_ENV !== 'production') {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (process.env.NODE_ENV !== 'production') {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (process.env.NODE_ENV !== 'production') {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (process.env.NODE_ENV !== 'production') {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var AdditionalConsiderations, Decision, GdtEditorWithApply, Judgement, ResearchEvidences, Subgroup, Tabs, createReactClass;

Judgement = __webpack_require__(60);

ResearchEvidences = __webpack_require__(61);

AdditionalConsiderations = __webpack_require__(66);

Decision = __webpack_require__(67);

GdtEditorWithApply = Editor.EditorWithApply;

Tabs = __webpack_require__(33);

createReactClass = __webpack_require__(0);

Subgroup = createReactClass({
  displayName: 'Subgroup Component',
  onApply: function() {
    return this.saveContent();
  },
  onCancel: function() {
    var ref;
    return this.gdtEditor.resetContent((ref = this.props.criteria.get('decision')) != null ? ref.get('comments') : void 0);
  },
  saveContent: function() {
    return this.props.actions.updateContentEditableContent(this.props.index + "#criteria", this.gdtEditor.getEditorContent());
  },
  getContent: function(section) {
    var ref;
    return (ref = section.get('contentConsensus')) != null ? ref : section.get('content');
  },
  changeDecision: function(sectionId, value) {
    return this.props.actions.changeAndSaveCriteriaDecision(sectionId, value);
  },
  getEditorEl: function(el) {
    return this.gdtEditor = el != null ? el.gdtEditor : void 0;
  },
  render: function() {
    var additionalConsiderations, ref, researchEvidences;
    researchEvidences = this.getContent(this.props.researchEvidences);
    additionalConsiderations = this.getContent(this.props.additionalConsiderations);
    return React.createElement("div", null, React.createElement("div", {
      "className": "top-tabs"
    }, React.createElement(Tabs.List, {
      "initiallyActive": 0
    }, React.createElement(Tabs.Tab, {
      "caption": 'Judgement'
    }, React.createElement("div", {
      "className": "inner-tab-content"
    }, React.createElement(Judgement, {
      "criteria": this.props.criteria
    }))), React.createElement(Tabs.Tab, {
      "caption": 'Research Evidences'
    }, React.createElement(ResearchEvidences, {
      "attachments": this.props.attachments,
      "content": researchEvidences,
      "references": this.props.references
    })), React.createElement(Tabs.Tab, {
      "caption": 'Additional Considerations'
    }, React.createElement(AdditionalConsiderations, {
      "content": additionalConsiderations
    })))), React.createElement("div", {
      "className": "bottom-tabs"
    }, React.createElement(Tabs.List, {
      "initiallyActive": 0
    }, React.createElement(Tabs.Tab, {
      "caption": 'Decision'
    }, React.createElement("div", {
      "className": "inner-tab-content"
    }, React.createElement(Decision, {
      "sectionId": this.props.index,
      "criteria": this.props.criteria,
      "changeDecision": this.changeDecision,
      "isEditable": this.props.isEditable
    }))), React.createElement(Tabs.Tab, {
      "caption": 'Comments'
    }, React.createElement("div", {
      "className": "draft-editor"
    }, React.createElement(GdtEditorWithApply, {
      "ref": this.getEditorEl,
      "stickControlsTo": '#presentations',
      "editorContent": (ref = this.props.criteria.get('decision')) != null ? ref.get('comments') : void 0,
      "onCancel": this.onCancel,
      "onApply": this.onApply,
      "onBlur": this.saveContent,
      "readOnly": !this.props.isEditable
    }))))));
  }
});

module.exports = Subgroup;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Judgement, createReactClass;

createReactClass = __webpack_require__(0);

Judgement = createReactClass({
  displayName: "Judgement",
  getSelectedText: function() {
    var additionalOptions, options, ref;
    options = this.props.criteria.get('options');
    additionalOptions = this.props.criteria.get('additionalOptions');
    options = options.concat(additionalOptions);
    return (ref = options.find((function(_this) {
      return function(obj) {
        return obj.get('value') === _this.props.criteria.get('selectedOption');
      };
    })(this))) != null ? ref.get('text') : void 0;
  },
  render: function() {
    return React.createElement("div", null, (this.props.criteria.get('selectedOption') ? this.getSelectedText() : ""));
  }
});

module.exports = Judgement;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var ResearchEvidences, StaticContentFromDraftJS, StaticHtmlContent, createReactClass;

StaticHtmlContent = __webpack_require__(3);

StaticContentFromDraftJS = __webpack_require__(19);

createReactClass = __webpack_require__(0);

ResearchEvidences = createReactClass({
  displayName: "ResearchEvidences",
  render: function() {
    return React.createElement(StaticHtmlContent, Object.assign({}, this.props));
  }
});

module.exports = ResearchEvidences;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (process.env.NODE_ENV !== "production") {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(32);
var assign = __webpack_require__(11);

var ReactPropTypesSecret = __webpack_require__(18);
var has = __webpack_require__(31);
var checkPropTypes = __webpack_require__(30);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(18);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var AdditionalConsiderations, StaticHtmlContent, createReactClass;

StaticHtmlContent = __webpack_require__(3);

createReactClass = __webpack_require__(0);

AdditionalConsiderations = createReactClass({
  displayName: "AdditionalConsiderations",
  render: function() {
    return React.createElement(StaticHtmlContent, {
      "content": this.props.content
    });
  }
});

module.exports = AdditionalConsiderations;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Decision, bool, createReactClass, func, instanceOf, ref, string;

ref = __webpack_require__(1), bool = ref.bool, func = ref.func, string = ref.string, instanceOf = ref.instanceOf;

createReactClass = __webpack_require__(0);

Decision = createReactClass({
  displayName: 'DecisionComponent',
  propTypes: {
    sectionId: string.isRequired,
    isEditable: bool.isRequired,
    changeDecision: func.isRequired,
    criteria: instanceOf(Immutable.Map).isRequired
  },
  decisionChanged: function(e) {
    if (!this.props.isEditable) {
      return;
    }
    return this.props.changeDecision(this.props.sectionId, e.currentTarget.value);
  },
  getInput: function(option, selectedOption) {
    var checked, name, props, value;
    value = option.get('value');
    name = this.props.sectionId + "-decision";
    checked = value === selectedOption;
    props = this.props.isEditable ? {
      onChange: this.decisionChanged,
      defaultChecked: checked
    } : {
      readOnly: true,
      checked: checked
    };
    return React.createElement("label", null, React.createElement("input", Object.assign({
      "type": "radio",
      "id": name + "-" + value,
      "value": value,
      "name": name
    }, props)), React.createElement("span", null, option.get('text')));
  },
  render: function() {
    var selectedOption;
    selectedOption = this.props.criteria.getIn(['decision', 'selectedOption'], null);
    return React.createElement("div", {
      "className": "detailed decision"
    }, React.createElement("div", {
      "className": "radio-buttons"
    }, React.createElement("ul", null, this.props.criteria.get('options').map((function(_this) {
      return function(option) {
        return React.createElement("li", {
          "key": option.get('value')
        }, _this.getInput(option, selectedOption));
      };
    })(this)), React.createElement("li", {
      "className": "additional-options-separator"
    }), this.props.criteria.get('additionalOptions').map((function(_this) {
      return function(option) {
        return React.createElement("li", {
          "key": option.get('value')
        }, _this.getInput(option, selectedOption));
      };
    })(this)))));
  }
});

module.exports = Decision;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Background, CollapsiblePanel, LabelWithContentEditable, LabelWithInput, LabelWithText, MainOutcomes, StaticHtmlContent, createReactClass, fromQuestionModel, htmlContent, notEditable,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

LabelWithText = __webpack_require__(69);

MainOutcomes = __webpack_require__(70);

LabelWithInput = __webpack_require__(71);

LabelWithContentEditable = __webpack_require__(72);

CollapsiblePanel = __webpack_require__(29);

StaticHtmlContent = __webpack_require__(3);

createReactClass = __webpack_require__(0);

notEditable = ['patients', 'intervention', 'comparison', 'mainOutcomes', 'purpose', 'role', 'population', 'linkedTreatments', 'anticipatedOutcomes'];

htmlContent = ['perspective', 'setting'];

fromQuestionModel = ['patients', 'intervention', 'option', 'comparison', 'population', 'setting'];

Background = createReactClass({
  displayName: "Background",
  getInitialState: function() {
    return {
      editing: false
    };
  },
  updateProp: function(attr, value) {
    return this.props.actions.updateBackground({
      'attr': attr,
      'value': value
    });
  },
  handleUserInput: function(attr) {
    return this.updateProp(attr.sectionId, attr.content);
  },
  _prepareItems: function(section, index) {
    var content, contentAutoGenerated, editable, hasHtmlContent;
    if (index === 'background') {
      return;
    }
    if (this.props.questionData.get('type') === 'diagnostic' && !this.props.questionData.get('comparatorTestPresent', false) && index === 'comparison') {
      return;
    }
    editable = this.props.isEditable && this.state.editing && indexOf.call(notEditable, index) < 0;
    hasHtmlContent = indexOf.call(htmlContent, index) >= 0;
    content = indexOf.call(fromQuestionModel, index) >= 0 ? (index = (function() {
      switch (index) {
        case 'population':
          return 'healthProblemOrPopulation';
        case 'setting':
          return 'settings';
        case 'option':
          return 'intervention';
        case 'intervention':
          if (this.props.questionData.get('type') === 'diagnostic') {
            return 'indexTest';
          } else {
            return 'intervention';
          }
          break;
        case 'comparison':
          if (this.props.questionData.get('type') === 'diagnostic') {
            return 'comparatorTest';
          } else {
            return 'comparison';
          }
          break;
        default:
          return index;
      }
    }).call(this), contentAutoGenerated = section.get('autoContentGenerationOn'), contentAutoGenerated === false ? section.get('content', '') : this.props.questionData.get(index, '')) : section.get('content', '');
    if (hasHtmlContent) {
      return React.createElement(LabelWithContentEditable, {
        "className": "section-content",
        "key": section.get('name'),
        "label": section.get('name'),
        "name": "background-" + index,
        "content": content,
        "isEditable": editable,
        "handleUserInput": this.handleUserInput
      });
    } else if (editable) {
      return React.createElement(LabelWithInput, {
        "className": "section-content",
        "ref": index,
        "key": section.get('name'),
        "name": "background-" + index,
        "label": section.get('name'),
        "value": content,
        "onChange": this.updateProp
      });
    } else {
      return React.createElement(LabelWithText, {
        "key": section.get('name'),
        "className": "section-content",
        "title": section.get('name'),
        "value": content
      });
    }
  },
  _getMainOutcomesValue: function(section, index) {
    if (section.get('autoContentGenerationOn') === false || index === 'anticipatedOutcomes') {
      return section.get('content', '');
    } else {
      return this.props.questionData.get('outcomes', Immutable.Map()).reduce(function(outcomesString, o) {
        var outcomeName;
        outcomeName = o.get('name');
        return outcomesString + " " + outcomeName + ";";
      }, '');
    }
  },
  renderBackgroundPolicymakers: function() {
    var ref, ref1, ref2;
    return React.createElement("div", null, React.createElement("div", {
      "className": "pull-right clearfix"
    }, (this.props.isEditable ? this.state.editing ? React.createElement("button", {
      "className": "save",
      "onClick": this.save
    }) : React.createElement("button", {
      "className": "edit",
      "onClick": this.toggleEditMode
    }) : void 0)), React.createElement("div", {
      "className": "background policymakers"
    }, React.createElement(CollapsiblePanel, {
      "title": (ref = this.props.sections.get('background')) != null ? ref.get('description') : void 0,
      "className": "panel-toggle block"
    }, this.props.question.map((function(_this) {
      return function(section, index) {
        var sectionName;
        if (index === 'mainOutcomes' || index === 'anticipatedOutcomes') {
          sectionName = section.get('name');
          return React.createElement(MainOutcomes, {
            "className": "section-content",
            "key": sectionName,
            "title": sectionName,
            "value": _this._getMainOutcomesValue(section, index)
          });
        } else {
          return _this._prepareItems(section, index);
        }
      };
    })(this)).toList()), (this.props.backgroundDetailSections ? React.createElement(CollapsiblePanel, {
      "title": (ref1 = this.props.sections.get('background')) != null ? (ref2 = ref1.get('details')) != null ? ref2.get('name') : void 0 : void 0,
      "className": "panel-toggle block"
    }, this.props.backgroundDetailSections.map((function(_this) {
      return function(section, index) {
        if (_this.props.isEditable && _this.state.editing) {
          return React.createElement(LabelWithInput, {
            "key": index,
            "ref": index,
            "className": "section-content",
            "name": "details-" + index,
            "label": section.get('description'),
            "value": section.get('content'),
            "onChange": _this.updateProp
          });
        } else {
          return React.createElement(LabelWithText, {
            "key": index,
            "className": "section-content",
            "title": section.get('description'),
            "value": section.get('content')
          });
        }
      };
    })(this)).toList()) : void 0)));
  },
  save: function() {
    this.props.actions.saveBackground();
    return this.setState({
      editing: false
    });
  },
  toggleEditMode: function() {
    return this.setState({
      editing: true
    });
  },
  _getContent: function(autoMode) {
    var ref, ref1;
    if (autoMode) {
      return (ref = this.props.question) != null ? ref.getIn(['background', 'content']) : void 0;
    } else {
      return (ref1 = this.props.presentationData.getIn(['sections', this.props.id, 'content'])) != null ? ref1 : "";
    }
  },
  render: function() {
    var autoMode, ref, ref1;
    autoMode = (ref = this.props.presentationData.getIn(['sections', this.props.id, 'autoMode'])) != null ? ref : true;
    return React.createElement("div", null, (this.props.type === 'policymakers' ? this.renderBackgroundPolicymakers() : void 0), React.createElement("h4", {
      "className": "section-title"
    }, (ref1 = this.props.question.get('background')) != null ? ref1.get('name') : void 0), React.createElement("div", {
      "className": "draft-editor"
    }, React.createElement(StaticHtmlContent, {
      "content": this._getContent(autoMode),
      "references": this.props.references
    })));
  }
});

module.exports = Background;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var LabelWithText, createReactClass;

createReactClass = __webpack_require__(0);

LabelWithText = createReactClass({
  displayName: "LabelWithText",
  render: function() {
    var classes;
    classes = classNames(this.props.className, 'label-with-text');
    return React.createElement("div", {
      "className": classes
    }, React.createElement("label", null, this.props.title), React.createElement("span", null, this.props.value));
  }
});

module.exports = LabelWithText;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var MainOutcomes, StaticContentFromDraftJS;

StaticContentFromDraftJS = __webpack_require__(19);

MainOutcomes = function(props) {
  var title, value;
  value = props.value, title = props.title;
  return React.createElement("div", {
    "className": classNames(props.className, "main-outcomes")
  }, React.createElement("label", null, title), (Immutable.Map.isMap(value) ? React.createElement("div", {
    "className": "main-outcomes-content draft"
  }, React.createElement(StaticContentFromDraftJS, {
    "content": value
  })) : React.createElement("div", {
    "className": "main-outcomes-content",
    "dangerouslySetInnerHTML": {
      __html: value
    }
  })), React.createElement("div", {
    "className": "clearfix"
  }));
};

module.exports = MainOutcomes;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var LabelWithInput, PropTypes, createReactClass;

PropTypes = __webpack_require__(1);

createReactClass = __webpack_require__(0);

LabelWithInput = createReactClass({
  displayName: "LabelWithInput",
  propTypes: {
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string
  },
  getInitialState: function() {
    return {
      value: this.props.value
    };
  },
  onChange: function(e) {
    return this.props.onChange(e.target.name, e.target.value);
  },
  render: function() {
    var classes;
    classes = classNames(this.props.className, 'label-with-input');
    return React.createElement("div", {
      "className": classes
    }, React.createElement("label", null, this.props.label), React.createElement("input", {
      "ref": this.props.name,
      "type": "text",
      "name": this.props.name,
      "defaultValue": this.state.value,
      "onChange": this.onChange
    }));
  }
});

module.exports = LabelWithInput;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var GdtEditorWithApply, LabelWithContentEditable, StaticHtmlContent, bool, createReactClass, func, instanceOf, oneOfType, ref, string;

StaticHtmlContent = __webpack_require__(3);

ref = __webpack_require__(1), string = ref.string, bool = ref.bool, func = ref.func, instanceOf = ref.instanceOf, oneOfType = ref.oneOfType;

createReactClass = __webpack_require__(0);

GdtEditorWithApply = Editor.EditorWithApply;

LabelWithContentEditable = createReactClass({
  displayName: "LabelWithContentEditable",
  propTypes: {
    label: string,
    name: string,
    content: oneOfType([instanceOf(Immutable.Map), string]),
    isEditable: bool,
    handleUserInput: func
  },
  onApply: function() {
    return this.saveContent();
  },
  saveContent: function() {
    return this.props.handleUserInput({
      content: this.gdtEditor.getEditorContent(),
      sectionId: this.props.name
    });
  },
  onCancel: function() {
    return this.gdtEditor.resetContent(this.props.content);
  },
  getEditorEl: function(el) {
    return this.gdtEditor = el != null ? el.gdtEditor : void 0;
  },
  render: function() {
    var editorContainerClass;
    editorContainerClass = classNames({
      'draft-editor': this.props.isEditable
    }, "draft-content");
    return React.createElement("div", {
      "className": classNames(this.props.className, "label-with-contenteditable")
    }, React.createElement("label", null, this.props.label), React.createElement("div", {
      "className": editorContainerClass
    }, React.createElement(GdtEditorWithApply, {
      "ref": this.getEditorEl,
      "stickControlsTo": '#presentations',
      "editorContent": this.props.content,
      "onCancel": this.onCancel,
      "onApply": this.onApply,
      "onBlur": this.saveContent,
      "readOnly": !this.props.isEditable
    })));
  }
});

module.exports = LabelWithContentEditable;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, Decision, GdtEditorWithApply, bool, createReactClass, func, instanceOf, object, ref, string;

CustomRenderMixin = __webpack_require__(2);

createReactClass = __webpack_require__(0);

GdtEditorWithApply = Editor.EditorWithApply;

ref = __webpack_require__(1), bool = ref.bool, string = ref.string, instanceOf = ref.instanceOf, object = ref.object, func = ref.func;

Decision = createReactClass({
  displayName: "Decision",
  mixins: [CustomRenderMixin],
  propTypes: {
    isEditable: bool.isRequired,
    actions: object,
    decision: instanceOf(Immutable.Map).isRequired
  },
  decisionChanged: function(e) {
    return this.props.actions.changeAndSaveDecision(e.currentTarget.value);
  },
  onApply: function() {
    return this.saveContent();
  },
  onCancel: function() {
    return this.gdtEditor.resetContent(this.props.decision.get('content'));
  },
  saveContent: function() {
    return this.props.actions.updateContentEditableContent('decision#policymakers', this.gdtEditor.getEditorContent());
  },
  getInput: function(value, checked) {
    var props;
    props = this.props.isEditable ? {
      onChange: this.decisionChanged,
      defaultChecked: checked
    } : {
      checked: checked,
      readOnly: true
    };
    return React.createElement("input", Object.assign({
      "id": value,
      "name": "decision",
      "type": "radio",
      "value": value
    }, props));
  },
  getEditorEl: function(el) {
    return this.gdtEditor = el != null ? el.gdtEditor : void 0;
  },
  render: function() {
    var ref1;
    return React.createElement("div", {
      "className": "decision"
    }, React.createElement("h4", {
      "className": "section-title"
    }, this.props.decision.get('description')), (this.props.decision.get('options') ? React.createElement("div", {
      "className": "radio-buttons"
    }, React.createElement("ul", null, (ref1 = this.props.decision) != null ? ref1.get('options').map((function(_this) {
      return function(option) {
        var checked;
        checked = option.get('value') === _this.props.decision.get('selectedOption');
        return React.createElement("li", {
          "key": option.get('value')
        }, React.createElement("label", null, _this.getInput(option.get('value'), checked), React.createElement("span", null, option.get('text'))));
      };
    })(this)) : void 0)) : void 0), React.createElement("div", null, React.createElement("div", {
      "className": "draft-editor"
    }, React.createElement(GdtEditorWithApply, {
      "ref": this.getEditorEl,
      "stickControlsTo": '#presentations',
      "editorContent": this.props.decision.get('content'),
      "onCancel": this.onCancel,
      "onApply": this.onApply,
      "onBlur": this.saveContent,
      "readOnly": !this.props.isEditable
    }))));
  }
});

module.exports = Decision;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, ForDecisionContent, Implementation, StaticHtmlContent, Translation, bool, createReactClass, instanceOf, object, ref, string;

CustomRenderMixin = __webpack_require__(2);

ForDecisionContent = __webpack_require__(20);

StaticHtmlContent = __webpack_require__(3);

Translation = __webpack_require__(4);

createReactClass = __webpack_require__(0);

ref = __webpack_require__(1), bool = ref.bool, string = ref.string, instanceOf = ref.instanceOf, object = ref.object;

Implementation = createReactClass({
  displayName: "Implementation",
  propTypes: {
    actions: object,
    isEditable: bool.isRequired,
    currentEditable: string.isRequired,
    conclusions: instanceOf(Immutable.Map).isRequired
  },
  mixins: [CustomRenderMixin, Translation('')],
  save: function(content) {
    return this.props.actions.updateContentEditableContent("implementationConsiderations#conclusions#forDecision", content);
  },
  render: function() {
    var conclusions, ref1, sectionTitle, type;
    ref1 = this.props, conclusions = ref1.conclusions, type = ref1.type;
    sectionTitle = this.i18n('presentations:section_titles.for_recommendation', {
      'sectionName': conclusions.get('description')
    });
    return React.createElement("div", {
      "className": "implementation"
    }, React.createElement("h4", {
      "className": "section-title"
    }, sectionTitle), (type === 'clinicians' ? React.createElement(StaticHtmlContent, {
      "content": conclusions.get('content')
    }) : React.createElement("div", null, React.createElement("div", {
      "className": "for-recommendation-content"
    }, React.createElement(StaticHtmlContent, {
      "content": conclusions.get('content')
    })), React.createElement("div", {
      "className": "for-decision-content"
    }, React.createElement(ForDecisionContent, {
      "save": this.save,
      "isEditable": this.props.isEditable,
      "sectionName": conclusions.get('description'),
      "content": conclusions.getIn(['forDecision', 'content'])
    })))));
  }
});

module.exports = Implementation;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, DetailedJustification, ForDecisionContent, Justification, StaticHtmlContent, Translation, bool, createReactClass, instanceOf, object, ref, string;

CustomRenderMixin = __webpack_require__(2);

DetailedJustification = __webpack_require__(34);

StaticHtmlContent = __webpack_require__(3);

ForDecisionContent = __webpack_require__(20);

Translation = __webpack_require__(4);

createReactClass = __webpack_require__(0);

ref = __webpack_require__(1), bool = ref.bool, string = ref.string, instanceOf = ref.instanceOf, object = ref.object;

Justification = createReactClass({
  displayName: "Justification",
  propTypes: {
    actions: object,
    isEditable: bool.isRequired,
    currentEditable: string.isRequired,
    conclusions: instanceOf(Immutable.Map).isRequired
  },
  mixins: [CustomRenderMixin, Translation('')],
  save: function(content) {
    return this.props.actions.updateContentEditableContent("justification#conclusions#forDecision", content);
  },
  render: function() {
    var conclusions, contentClasses, sectionTitle;
    conclusions = this.props.conclusions;
    contentClasses = classNames('for-recommendation-content', 'draft-editor', {
      'editable': this.props.isEditable,
      'clinicians': this.props.type === 'clinicians',
      'policymakers': this.props.type === 'policymakers'
    });
    sectionTitle = this.i18n('presentations:section_titles.for_recommendation', {
      'sectionName': conclusions.get('description')
    });
    return React.createElement("div", {
      "className": "justification"
    }, React.createElement("h4", {
      "className": "section-title"
    }, sectionTitle), (this.props.type === 'clinicians' ? React.createElement("div", {
      "className": contentClasses
    }, React.createElement(StaticHtmlContent, {
      "content": conclusions.get('content')
    })) : React.createElement("div", null, React.createElement("div", {
      "className": contentClasses
    }, React.createElement(StaticHtmlContent, {
      "content": conclusions.get('content')
    }), React.createElement(DetailedJustification, {
      "id": "detailedJustification",
      "assessmentSections": this.props.assessmentSections,
      "conclusions": conclusions,
      "type": this.props.type
    })), React.createElement("div", {
      "className": "for-decision-content"
    }, React.createElement(ForDecisionContent, {
      "save": this.save,
      "isEditable": this.props.isEditable,
      "sectionName": conclusions.get('description'),
      "content": conclusions.getIn(['forDecision', 'content'])
    })))));
  }
});

module.exports = Justification;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, ForDecisionContent, MonitoringAndEvaluation, StaticHtmlContent, Translation, bool, createReactClass, instanceOf, object, ref, string;

CustomRenderMixin = __webpack_require__(2);

ForDecisionContent = __webpack_require__(20);

StaticHtmlContent = __webpack_require__(3);

Translation = __webpack_require__(4);

createReactClass = __webpack_require__(0);

ref = __webpack_require__(1), bool = ref.bool, string = ref.string, instanceOf = ref.instanceOf, object = ref.object;

MonitoringAndEvaluation = createReactClass({
  displayName: "MonitoringAndEvaluation",
  propTypes: {
    actions: object,
    isEditable: bool.isRequired,
    currentEditable: string.isRequired,
    conclusions: instanceOf(Immutable.Map).isRequired
  },
  mixins: [CustomRenderMixin, Translation('')],
  save: function(content) {
    return this.props.actions.updateContentEditableContent("monitoringAndEvaluation#conclusions#forDecision", content);
  },
  render: function() {
    var conclusions, sectionTitle;
    conclusions = this.props.conclusions;
    sectionTitle = this.i18n('presentations:section_titles.for_recommendation', {
      'sectionName': conclusions.get('description')
    });
    return React.createElement("div", {
      "className": "monitoring"
    }, React.createElement("h4", {
      "className": "section-title"
    }, sectionTitle), React.createElement("div", {
      "className": "for-recommendation-content"
    }, React.createElement(StaticHtmlContent, {
      "content": conclusions.get('content')
    })), React.createElement("div", {
      "className": "for-decision-content"
    }, React.createElement(ForDecisionContent, {
      "save": this.save,
      "isEditable": this.props.isEditable,
      "sectionName": conclusions.get('description'),
      "content": conclusions.getIn(['forDecision', 'content'])
    })));
  }
});

module.exports = MonitoringAndEvaluation;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, StaticHtmlContent, SubgroupConsiderations, createReactClass;

StaticHtmlContent = __webpack_require__(3);

CustomRenderMixin = __webpack_require__(2);

createReactClass = __webpack_require__(0);

SubgroupConsiderations = createReactClass({
  displayName: "SubgroupConsiderations",
  mixins: [CustomRenderMixin],
  getInitialState: function() {
    var ref, ref1, ref2, ref3;
    return {
      contentLabel: (ref = (ref1 = this.props.conclusions) != null ? ref1.get('description') : void 0) != null ? ref : "",
      content: (ref2 = (ref3 = this.props.conclusions) != null ? ref3.get('content') : void 0) != null ? ref2 : ""
    };
  },
  _getContent: function(autoMode) {
    var ref;
    if (autoMode) {
      return this.props.conclusions.get('content');
    } else {
      return (ref = this.props.presentationData.getIn(['sections', this.props.id, 'content'])) != null ? ref : "";
    }
  },
  render: function() {
    var autoMode, ref;
    autoMode = (ref = this.props.presentationData.getIn(['sections', this.props.id, 'autoMode'])) != null ? ref : true;
    return React.createElement("div", null, React.createElement("h4", {
      "className": "section-title"
    }, this.props.conclusions.get('description')), React.createElement("div", {
      "className": "draft-editor"
    }, React.createElement(StaticHtmlContent, {
      "content": this._getContent(autoMode),
      "references": this.props.references
    })));
  }
});

module.exports = SubgroupConsiderations;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

var ISoFDx;

module.exports = ISoFDx = (function() {
  function ISoFDx(container, data) {
    this.container = container;
    this.data = data;
    angular.module('isofDxApp').value('isofData', this.data);
    angular.element(this.container).ready((function(_this) {
      return function() {
        var cmp;
        if (!angular.element(_this.container).scope()) {
          return cmp = angular.bootstrap(_this.container, ['isofDxApp']);
        }
      };
    })(this));
  }

  ISoFDx.prototype.rerender = function(container, data) {
    this.container = container;
    this.data = data;
    angular.element(this.container).removeData();
    angular.module('isofDxApp').value('isofData', this.data);
    return angular.bootstrap(this.container, ['isofDxApp']);
  };

  return ISoFDx;

})();


/***/ }),
/* 79 */
/***/ (function(module, exports) {

var ISoFTx;

module.exports = ISoFTx = (function() {
  function ISoFTx(container, data, onSavePlainLanguageStatement) {
    this.container = container;
    this.data = data;
    this.onSavePlainLanguageStatement = onSavePlainLanguageStatement;
    angular.module('isofTxApp').value('isofData', this.data);
    angular.module('isofTxApp').value('onSavePlainLanguageStatement', this.onSavePlainLanguageStatement);
    angular.element(this.container).ready((function(_this) {
      return function() {
        return angular.bootstrap(_this.container, ['isofTxApp']);
      };
    })(this));
  }

  ISoFTx.prototype.rerender = function(container, data, onSavePlainLanguageStatement) {
    this.container = container;
    this.data = data;
    this.onSavePlainLanguageStatement = onSavePlainLanguageStatement;
    angular.element(this.container).removeData();
    angular.module('isofTxApp').value('isofData', this.data);
    angular.module('isofTxApp').value('onSavePlainLanguageStatement', this.onSavePlainLanguageStatement);
    return angular.bootstrap(this.container, ['isofTxApp']);
  };

  return ISoFTx;

})();


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, GdtEditorWithApply, PatientsTab, Translation, bool, createReactClass, instanceOf, object, ref, string;

CustomRenderMixin = __webpack_require__(2);

Translation = __webpack_require__(4);

createReactClass = __webpack_require__(0);

GdtEditorWithApply = Editor.EditorWithApply;

ref = __webpack_require__(1), bool = ref.bool, string = ref.string, instanceOf = ref.instanceOf, object = ref.object;

PatientsTab = createReactClass({
  displayName: 'PatientsTab',
  propTypes: {
    actions: object.isRequired,
    isEditable: bool.isRequired,
    sectionData: instanceOf(Immutable.Map).isRequired,
    sectionId: string.isRequired
  },
  mixins: [CustomRenderMixin, Translation('')],
  getEditorEl: function(partId) {
    return (function(_this) {
      return function(el) {
        return _this[partId + "Editor"] = el != null ? el.gdtEditor : void 0;
      };
    })(this);
  },
  getAdditionalFieldPartId: function() {
    switch (this.props.sectionId) {
      case 'whoIsThisFor':
        return 'whoIsThisFor';
      case 'whatItMeansForYou':
        return 'speakWithHCProfessional';
      default:
        return null;
    }
  },
  getDefaultContent: function(partId) {
    switch (partId) {
      case 'whyThisRecommendation':
        return this.i18n('presentations:default_content.why_this_recommendation_content');
      case 'whatYouCanDo':
        return this.i18n('presentations:default_content.what_you_can_do_content');
      case 'speakWithHCProfessional':
        return this.i18n('presentations:default_content.speak_with_healthcare_professional_content');
      default:
        return '';
    }
  },
  onCancel: function(partId) {
    return (function(_this) {
      return function() {
        return _this[partId + "Editor"].resetContent(_this.props.sectionData.getIn(['parts', partId, 'content']) || _this.getDefaultContent(partId));
      };
    })(this);
  },
  _savePartContent: function(partId, content) {
    return this.props.actions.updatePresentationPatientsSectionContent({
      sectionId: this.props.sectionId,
      partId: partId,
      content: content
    });
  },
  saveContent: function(partId) {
    return (function(_this) {
      return function() {
        return _this._savePartContent(partId, _this[partId + "Editor"].getEditorContent());
      };
    })(this);
  },
  onSectionMainContentChange: function(partId) {
    return (function(_this) {
      return function(arg) {
        var newValue, target;
        target = arg.target;
        newValue = target.value;
        if (target.defaultValue === newValue) {
          return;
        }
        return _this._savePartContent(partId, newValue);
      };
    })(this);
  },
  onSectionFieldChange: function(partId, fieldIdx) {
    return (function(_this) {
      return function(evt) {
        var newContent;
        newContent = evt.target.value;
        if (newContent === evt.target.defaultValue) {
          return;
        }
        return _this.props.actions.updatePresentationSectionFieldContent({
          content: newContent,
          fieldIndex: fieldIdx,
          partId: partId,
          sectionId: _this.props.sectionId
        });
      };
    })(this);
  },
  onAddField: function() {
    return this.props.actions.addPresentationSectionField({
      sectionId: this.props.sectionId,
      partId: this.getAdditionalFieldPartId()
    });
  },
  onRemoveField: function(partId, fieldIdx) {
    return (function(_this) {
      return function() {
        return _this.props.actions.removePresentationSectionField({
          sectionId: _this.props.sectionId,
          partId: partId,
          fieldIndex: fieldIdx
        });
      };
    })(this);
  },
  renderSectionPart: function(part, partId) {
    var additionalFields, classess, editorApplyHandler, editorCancelHandler, partContent, readOnlyMode;
    partContent = part.get('content');
    additionalFields = part.get('additionalFields', Immutable.List());
    readOnlyMode = !this.props.isEditable;
    editorCancelHandler = this.onCancel(partId);
    editorApplyHandler = this.saveContent(partId);
    return React.createElement("div", {
      "key": partId
    }, React.createElement("h4", {
      "className": 'section-title'
    }, part.get('name')), (partId === 'whoIsThisFor' ? (classess = classNames('bullet-item', {
      'readonly': readOnlyMode,
      'empty': _.isEmpty(part.get('content'))
    }), React.createElement("div", {
      "className": classess
    }, React.createElement("input", {
      "onBlur": this.onSectionMainContentChange(partId),
      "type": 'text',
      "defaultValue": part.get('content'),
      "readOnly": readOnlyMode
    }))) : React.createElement("div", {
      "className": classNames("draft-editor", {
        'readonly': readOnlyMode
      })
    }, React.createElement(GdtEditorWithApply, {
      "ref": this.getEditorEl(partId),
      "stickControlsTo": '#presentations',
      "editorContent": part.get('content') || this.getDefaultContent(partId),
      "onCancel": editorCancelHandler,
      "onApply": editorApplyHandler,
      "onBlur": editorApplyHandler,
      "readOnly": readOnlyMode
    }))), (!additionalFields.isEmpty() ? additionalFields.map((function(_this) {
      return function(field, idx) {
        classess = classNames('section-additional-field', 'bullet-item', {
          'readonly': readOnlyMode,
          'empty': _.isEmpty(field.get('content'))
        });
        return React.createElement("div", {
          "className": classess,
          "key": idx
        }, React.createElement("input", {
          "className": 'additional-field',
          "onBlur": _this.onSectionFieldChange(partId, idx),
          "type": 'text',
          "defaultValue": field.get('content'),
          "readOnly": readOnlyMode
        }), (!readOnlyMode ? React.createElement("button", {
          "className": 'remove',
          "onMouseDown": _this.onRemoveField(partId, idx),
          "title": _this.i18n('presentations:titles.remove')
        }) : void 0));
      };
    })(this)) : void 0));
  },
  render: function() {
    var isEditable, ref1, sectionData, sectionId, titleKey;
    ref1 = this.props, sectionData = ref1.sectionData, sectionId = ref1.sectionId, isEditable = ref1.isEditable;
    return React.createElement("div", {
      "className": 'patients-tab'
    }, sectionData.get('parts', Immutable.Map()).map(this.renderSectionPart).toList(), (isEditable && (sectionId === 'whatItMeansForYou' || sectionId === 'whoIsThisFor') ? (titleKey = sectionId === 'whatItMeansForYou' ? 'add_topic' : 'add_item', React.createElement("div", {
      "className": "add-field-control"
    }, React.createElement("button", {
      "className": 'add',
      "onClick": this.onAddField,
      "title": this.i18n("presentations:titles." + titleKey)
    }, React.createElement("span", null, this.i18n('presentations:actions.add'))))) : void 0));
  }
});

module.exports = PatientsTab;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, RelatedRecommendations, StaticHtmlContent, Translation, createReactClass, instanceOf;

CustomRenderMixin = __webpack_require__(2);

StaticHtmlContent = __webpack_require__(3);

Translation = __webpack_require__(4);

instanceOf = __webpack_require__(1).instanceOf;

createReactClass = __webpack_require__(0);

RelatedRecommendations = createReactClass({
  displayName: "RelatedRecommendations",
  mixins: [CustomRenderMixin, Translation('')],
  propTypes: {
    relatedQuestions: instanceOf(Immutable.Map).isRequired,
    relatedRecommendations: instanceOf(Immutable.Map).isRequired
  },
  render: function() {
    var ref, relatedQuestions, relatedRecommendations;
    ref = this.props, relatedRecommendations = ref.relatedRecommendations, relatedQuestions = ref.relatedQuestions;
    return React.createElement("div", {
      "className": "related-recommendations"
    }, React.createElement("h4", {
      "className": "section-title"
    }, this.i18n('presentations:section_titles.related_recommendations')), relatedQuestions.mapEntries(function(arg, index) {
      var qid, question, rrList;
      qid = arg[0], question = arg[1];
      rrList = React.createElement("div", {
        "key": qid
      }, React.createElement("div", {
        "className": "bold"
      }, index + 1, ". ", question.get('question')), relatedRecommendations.get(qid, Immutable.Map).map(function(etd, etdId) {
        return React.createElement(StaticHtmlContent, {
          "key": etdId,
          "content": etd.get('content')
        });
      }).toList());
      return [qid, rrList];
    }).toList());
  }
});

module.exports = RelatedRecommendations;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(83);

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(84),
    deburr = __webpack_require__(85),
    words = __webpack_require__(94);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(86),
    toString = __webpack_require__(36);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(87);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21),
    arrayMap = __webpack_require__(90),
    isArray = __webpack_require__(22),
    isSymbol = __webpack_require__(91);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(10),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(95),
    hasUnicodeWord = __webpack_require__(96),
    toString = __webpack_require__(36),
    unicodeWords = __webpack_require__(97);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(99),
    createAssigner = __webpack_require__(154);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(100),
    assignMergeValue = __webpack_require__(39),
    baseFor = __webpack_require__(129),
    baseMergeDeep = __webpack_require__(131),
    isObject = __webpack_require__(6),
    keysIn = __webpack_require__(48),
    safeGet = __webpack_require__(47);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(12),
    stackClear = __webpack_require__(106),
    stackDelete = __webpack_require__(107),
    stackGet = __webpack_require__(108),
    stackHas = __webpack_require__(109),
    stackSet = __webpack_require__(110);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(13);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(13);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(13);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(13);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(12);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 108 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(12),
    Map = __webpack_require__(38),
    MapCache = __webpack_require__(116);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(24),
    isMasked = __webpack_require__(112),
    isObject = __webpack_require__(6),
    toSource = __webpack_require__(114);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(113);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(7);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(117),
    mapCacheDelete = __webpack_require__(124),
    mapCacheGet = __webpack_require__(126),
    mapCacheHas = __webpack_require__(127),
    mapCacheSet = __webpack_require__(128);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(118),
    ListCache = __webpack_require__(12),
    Map = __webpack_require__(38);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(119),
    hashDelete = __webpack_require__(120),
    hashGet = __webpack_require__(121),
    hashHas = __webpack_require__(122),
    hashSet = __webpack_require__(123);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(15);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(15);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(15);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(15);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(16);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(16);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(16);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(16);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(130);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(39),
    cloneBuffer = __webpack_require__(132),
    cloneTypedArray = __webpack_require__(133),
    copyArray = __webpack_require__(136),
    initCloneObject = __webpack_require__(137),
    isArguments = __webpack_require__(43),
    isArray = __webpack_require__(22),
    isArrayLikeObject = __webpack_require__(141),
    isBuffer = __webpack_require__(45),
    isFunction = __webpack_require__(24),
    isObject = __webpack_require__(6),
    isPlainObject = __webpack_require__(143),
    isTypedArray = __webpack_require__(46),
    safeGet = __webpack_require__(47),
    toPlainObject = __webpack_require__(147);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(7);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)(module)))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(134);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(135);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(7);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(138),
    getPrototype = __webpack_require__(41),
    isPrototype = __webpack_require__(42);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(10),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(27),
    isObjectLike = __webpack_require__(8);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(10),
    getPrototype = __webpack_require__(41),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(10),
    isLength = __webpack_require__(44),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(37);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)(module)))

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(148),
    keysIn = __webpack_require__(48);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(149),
    baseAssignValue = __webpack_require__(25);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(25),
    eq = __webpack_require__(14);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(151),
    isArguments = __webpack_require__(43),
    isArray = __webpack_require__(22),
    isBuffer = __webpack_require__(45),
    isIndex = __webpack_require__(49),
    isTypedArray = __webpack_require__(46);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 151 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6),
    isPrototype = __webpack_require__(42),
    nativeKeysIn = __webpack_require__(153);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(155),
    isIterateeCall = __webpack_require__(162);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(50),
    overRest = __webpack_require__(156),
    setToString = __webpack_require__(158);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(157);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(159),
    shortOut = __webpack_require__(161);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(160),
    defineProperty = __webpack_require__(40),
    identity = __webpack_require__(50);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(14),
    isArrayLike = __webpack_require__(27),
    isIndex = __webpack_require__(49),
    isObject = __webpack_require__(6);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Patients, SectionTabs, createReactClass;

SectionTabs = __webpack_require__(17);

createReactClass = __webpack_require__(0);

Patients = createReactClass({
  displayName: "Patients",
  render: function() {
    return React.createElement(SectionTabs, {
      "actions": this.props.actions,
      "assessmentSections": this.props.assessmentSections,
      "conclusions": this.props.conclusions,
      "currentEditable": this.props.currentEditable,
      "displayContext": this.props.displayContext,
      "isEditable": this.props.isEditable,
      "isofData": this.props.isofData,
      "presentationData": this.props.presentationData,
      "relatedQuestions": this.props.relatedQuestions,
      "references": this.props.references,
      "relatedRecommendations": this.props.relatedRecommendations,
      "sections": this.props.sections,
      "sectionTabs": this.props.sectionTabs,
      "showSof": this.props.showSof,
      "type": "patients"
    });
  }
});

module.exports = Patients;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var Policymakers, SectionTabs, createReactClass;

SectionTabs = __webpack_require__(17);

createReactClass = __webpack_require__(0);

Policymakers = createReactClass({
  displayName: "Policymakers",
  render: function() {
    return React.createElement(SectionTabs, {
      "actions": this.props.actions,
      "assessment": this.props.assessment,
      "assessmentSections": this.props.assessmentSections,
      "attachments": this.props.attachments,
      "backgroundDetailSections": this.props.backgroundDetailSections,
      "conclusions": this.props.conclusions,
      "currentEditable": this.props.currentEditable,
      "isEditable": this.props.isEditable,
      "isofData": this.props.isofData,
      "presentationData": this.props.presentationData,
      "question": this.props.question,
      "questionData": this.props.questionData,
      "references": this.props.references,
      "relatedQuestions": this.props.relatedQuestions,
      "relatedRecommendations": this.props.relatedRecommendations,
      "sections": this.props.sections,
      "sectionTabs": this.props.sectionTabs,
      "showSof": this.props.showSof,
      "type": "policymakers"
    });
  }
});

module.exports = Policymakers;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var Card, CardContent, CardHeader, IsofBox, LngContext, PremiumPresentationForPatients, RecommendationSection, SectionBox, StaticHtmlContent, WhoIsThisForSection, oneOf, ref, useContext;

ref = window.ReactComponents, Card = ref.Card, CardHeader = ref.CardHeader, CardContent = ref.CardContent;

IsofBox = __webpack_require__(166);

SectionBox = __webpack_require__(167);

StaticHtmlContent = __webpack_require__(3);

RecommendationSection = __webpack_require__(170);

WhoIsThisForSection = __webpack_require__(171);

LngContext = __webpack_require__(9);

oneOf = __webpack_require__(1).oneOf;

useContext = React.useContext;

PremiumPresentationForPatients = function(arg) {
  var comparison, containerClasses, documentType, i18n, intervention, isIsofVisibleInPremiumView, isofData, language, presentationName, publicationDate, recommendation, recommendationContent, references, sections, theme, title, titleClasses, toggleSofTableInPremiumView;
  comparison = arg.comparison, documentType = arg.documentType, i18n = arg.i18n, intervention = arg.intervention, isIsofVisibleInPremiumView = arg.isIsofVisibleInPremiumView, isofData = arg.isofData, presentationName = arg.presentationName, publicationDate = arg.publicationDate, recommendation = arg.recommendation, recommendationContent = arg.recommendationContent, references = arg.references, sections = arg.sections, theme = arg.theme, toggleSofTableInPremiumView = arg.toggleSofTableInPremiumView;
  language = useContext(LngContext);
  title = (function() {
    switch (documentType) {
      case 'gps':
        return i18n('presentations:good_practice_statement');
      case 'additional-guidance':
        return i18n('presentations:additional_guidance');
      default:
        return i18n('presentations:recommendation');
    }
  })();
  titleClasses = classNames('presentation-title', containerClasses = classNames("presentation-content", "presentation-content__premium", 'theme', theme, {
    'text-rtl': language === 'fa' || language === 'ar'
  }));
  return React.createElement("div", {
    "className": containerClasses
  }, React.createElement("h1", {
    "className": 'presentation-title'
  }, presentationName), publicationDate && React.createElement("span", {
    "className": "publication-date"
  }, i18n('presentations:titles.publicationDate'), " (", new Date(publicationDate).toISOString().slice(0, 10), ")"), React.createElement("div", {
    "className": "clearfix"
  }), React.createElement("div", {
    "className": "card__box card__box__recommendation"
  }, React.createElement(Card, null, React.createElement(CardHeader, {
    "title": title
  }), React.createElement(CardContent, {
    "headerBackground": true
  }, React.createElement("div", {
    "className": "section recommendation_content"
  }, React.createElement(StaticHtmlContent, {
    "content": recommendationContent,
    "references": references
  })), React.createElement(WhoIsThisForSection, {
    "section": sections.get('whoIsThisFor')
  }), React.createElement(RecommendationSection, {
    "documentType": documentType,
    "intervention": intervention,
    "comparison": comparison,
    "recommendation": recommendation
  })))), React.createElement(SectionBox, {
    "parts": sections.getIn(['whyThisRecommendation', 'parts'], Immutable.Map()),
    "sectionsOrder": sections.getIn(['whyThisRecommendation', 'sectionsOrder'], Immutable.fromJS(['whyThisRecommendation', 'additionalInformation'])),
    "sectionName": sections.getIn(['whyThisRecommendation', 'name'], ""),
    "recommendation": recommendation
  }), !_.isEmpty(isofData != null ? isofData.outcomes : void 0) && React.createElement(IsofBox, {
    "isofData": isofData,
    "isIsofVisibleInPremiumView": isIsofVisibleInPremiumView,
    "toggleSofTableInPremiumView": toggleSofTableInPremiumView
  }), React.createElement(SectionBox, {
    "parts": sections.getIn(['whatItMeansForYou', 'parts'], Immutable.Map()),
    "sectionsOrder": sections.getIn(['whatItMeansForYou', 'sectionsOrder'], Immutable.fromJS(['whatYouCanDo', 'speakWithHCProfessional'])),
    "sectionName": sections.getIn(['whatItMeansForYou', 'name'], "")
  }));
};

PremiumPresentationForPatients.propTypes = {
  theme: oneOf(['orange', 'light-blue', 'gray', 'green', 'pink', 'dark-blue'])
};

PremiumPresentationForPatients.defaultProps = {
  theme: 'dark-blue'
};

module.exports = PremiumPresentationForPatients;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Card, CardContent, DynamicHeightContainer, IsofBox, SummaryOfFindings, Translation, bool, createReactClass, func, object, ref, ref1;

ref = __webpack_require__(1), bool = ref.bool, object = ref.object, func = ref.func;

createReactClass = __webpack_require__(0);

ref1 = window.ReactComponents, Card = ref1.Card, CardContent = ref1.CardContent, DynamicHeightContainer = ref1.DynamicHeightContainer;

SummaryOfFindings = __webpack_require__(35);

Translation = __webpack_require__(4);

IsofBox = createReactClass({
  displayName: "IsofBox",
  mixins: [Translation('')],
  propTypes: {
    isofData: object.isRequired,
    isIsofVisibleInPremiumView: bool,
    toggleSofTableInPremiumView: func.isRequired
  },
  getDefaultProps: function() {
    return {
      isIsofVisibleInPremiumView: false
    };
  },
  render: function() {
    var cardClasses, headerText, subHeaderText, triggerClasses;
    cardClasses = classNames('isof-card', {
      'isof-card--open': this.props.isIsofVisibleInPremiumView
    });
    triggerClasses = classNames('isof__trigger', {
      'isof__trigger--open': this.props.isIsofVisibleInPremiumView
    });
    headerText = this.props.isIsofVisibleInPremiumView ? this.i18n('presentations:buttons.close_benefits_and_harms') : this.i18n('presentations:buttons.see_benefits_and_harms');
    subHeaderText = this.props.isIsofVisibleInPremiumView ? this.i18n('presentations:buttons.close_table') : this.i18n('presentations:buttons.open_table');
    return React.createElement("div", {
      "className": "card__box"
    }, React.createElement(Card, {
      "className": cardClasses
    }, React.createElement(CardContent, null, React.createElement(DynamicHeightContainer, null, React.createElement("div", {
      "className": "isof__section"
    }, React.createElement("div", {
      "className": "isof__container"
    }), React.createElement("div", {
      "className": triggerClasses,
      "onClick": this.props.toggleSofTableInPremiumView
    }, React.createElement("h2", {
      "className": "section-title"
    }, headerText), subHeaderText), this.props.isIsofVisibleInPremiumView && React.createElement(SummaryOfFindings, {
      "isEditable": false,
      "isofData": this.props.isofData
    }))))));
  }
});

module.exports = IsofBox;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var Card, CardContent, CardHeader, CustomRenderMixin, PropTypes, SectionBox, SectionWithIcon, Sections, StaticHtmlContent, Translation, createReactClass, mapIconToKey, ref;

PropTypes = __webpack_require__(1);

createReactClass = __webpack_require__(0);

ref = window.ReactComponents, Card = ref.Card, CardHeader = ref.CardHeader, CardContent = ref.CardContent;

CustomRenderMixin = __webpack_require__(2);

Translation = __webpack_require__(4);

Sections = __webpack_require__(168);

SectionWithIcon = __webpack_require__(51);

StaticHtmlContent = __webpack_require__(3);

mapIconToKey = __webpack_require__(28).mapIconToKey;

SectionBox = createReactClass({
  displayName: "SectionBox",
  mixins: [CustomRenderMixin, Translation('')],
  propTypes: {
    sectionName: PropTypes.string.isRequired,
    parts: PropTypes.instanceOf(Immutable.Map).isRequired,
    recommendation: PropTypes.string,
    sectionsOrder: PropTypes.instanceOf(Immutable.List).isRequired
  },
  getDefaultProps: function() {
    return {
      recommendation: null
    };
  },
  render: function() {
    var benefitsAndHarms, parts, recommendation, ref1, references, sectionName, sectionsOrder;
    ref1 = this.props, sectionName = ref1.sectionName, parts = ref1.parts, recommendation = ref1.recommendation, sectionsOrder = ref1.sectionsOrder, references = ref1.references;
    benefitsAndHarms = parts.get('benefitsAndHarms', Immutable.Map());
    return React.createElement("div", {
      "className": "card__box"
    }, React.createElement(Card, null, React.createElement(CardHeader, {
      "title": sectionName
    }), React.createElement(CardContent, null, React.createElement(Sections, {
      "sections": parts,
      "sectionsOrder": sectionsOrder,
      "recommendation": recommendation
    }), (!benefitsAndHarms.isEmpty() ? React.createElement(SectionWithIcon, {
      "icon": mapIconToKey('benefitsAndHarms'),
      "title": benefitsAndHarms.get('name'),
      "className": 'benefitsAndHarms'
    }, React.createElement(StaticHtmlContent, {
      "content": benefitsAndHarms.get('content', ''),
      "references": references
    })) : void 0))));
  }
});

module.exports = SectionBox;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, PropTypes, SectionWithIcon, Sections, StaticHtmlContent, Translation, createReactClass, mapIconToKey, mapRecommendationToKey, node, ref, ref1, string;

PropTypes = __webpack_require__(1);

CustomRenderMixin = __webpack_require__(2);

SectionWithIcon = __webpack_require__(51);

StaticHtmlContent = __webpack_require__(3);

Translation = __webpack_require__(4);

ref = __webpack_require__(1), string = ref.string, node = ref.node;

createReactClass = __webpack_require__(0);

ref1 = __webpack_require__(28), mapIconToKey = ref1.mapIconToKey, mapRecommendationToKey = ref1.mapRecommendationToKey;

Sections = createReactClass({
  displayName: "Sections",
  mixins: [CustomRenderMixin, Translation('')],
  propTypes: {
    sections: PropTypes.instanceOf(Immutable.Map).isRequired,
    sectionsOrder: PropTypes.instanceOf(Immutable.List).isRequired
  },
  getDefaultContent: function(partId) {
    switch (partId) {
      case 'whyThisRecommendation':
        return this.i18n('presentations:default_content.why_this_recommendation_content');
      case 'whatYouCanDo':
        return this.i18n('presentations:default_content.what_you_can_do_content');
      case 'speakWithHCProfessional':
        return this.i18n('presentations:default_content.speak_with_healthcare_professional_content');
      default:
        return '';
    }
  },
  getNameForPart: function(key, part) {
    var recommendation, recommendationKey;
    recommendation = this.props.recommendation;
    if (key === 'whyThisRecommendation') {
      recommendationKey = mapRecommendationToKey(recommendation);
      return this.i18n('presentations:recommendations.why_this_recommendation', {
        'recommendation': recommendationKey ? this.i18n("presentations:labels." + recommendationKey) : ''
      });
    } else {
      return part.get('name');
    }
  },
  render: function() {
    var ref2, sections, sectionsOrder;
    ref2 = this.props, sections = ref2.sections, sectionsOrder = ref2.sectionsOrder;
    return React.createElement("div", {
      "className": "sections"
    }, sectionsOrder.map((function(_this) {
      return function(section) {
        if (section === 'benefitsAndHarms') {
          return null;
        }
        return React.createElement(SectionWithIcon, {
          "key": section,
          "icon": mapIconToKey(section),
          "title": _this.getNameForPart(section, sections.get(section)),
          "className": section
        }, React.createElement(StaticHtmlContent, {
          "content": sections.getIn([section, 'content']) || _this.getDefaultContent(section)
        }), !sections.getIn([section, 'additionalFields'], Immutable.List()).isEmpty() && React.createElement("ul", null, sections.getIn([section, 'additionalFields']).map(function(field, key) {
          if (!_.isEmpty(field.get('content'))) {
            return React.createElement("li", {
              "key": key
            }, field.get('content'));
          }
        })));
      };
    })(this)).toList());
  }
});

module.exports = Sections;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var SectionIcon, node, ref, string;

ref = __webpack_require__(1), string = ref.string, node = ref.node;

SectionIcon = function(arg) {
  var icon;
  icon = arg.icon;
  return React.createElement("span", {
    "className": classNames('section-icon', icon)
  });
};

module.exports = SectionIcon;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var AdditionalGuidanceDescription, CustomRenderMixin, GPSDescription, LngContext, RecommendationDescription, RecommendationSection, Translation, createReactClass, mapRecommendationToKey, mapRecommendationToLabel, node, oneOf, ref, ref1, string, useContext;

useContext = React.useContext;

ref = __webpack_require__(1), string = ref.string, node = ref.node, oneOf = ref.oneOf;

createReactClass = __webpack_require__(0);

LngContext = __webpack_require__(9);

CustomRenderMixin = __webpack_require__(2);

Translation = __webpack_require__(4);

ref1 = __webpack_require__(28), mapRecommendationToLabel = ref1.mapRecommendationToLabel, mapRecommendationToKey = ref1.mapRecommendationToKey;

RecommendationDescription = function(arg) {
  var i18n, iconClasses, language, recommendationKey;
  i18n = arg.i18n, recommendationKey = arg.recommendationKey;
  language = useContext(LngContext);
  iconClasses = classNames("recommendation__icons__icon", {
    "recommendation__icons__icon--conditional": recommendationKey === 'conditional' || recommendationKey === 'either',
    "recommendation__icons__icon--strong": recommendationKey === 'strong',
    'text-rtl': language === 'fa' || language === 'ar'
  });
  return React.createElement("div", {
    "className": "recommendation__description"
  }, React.createElement("div", {
    "className": "recommendation__icons"
  }, React.createElement("div", {
    "className": iconClasses
  }, React.createElement("div", {
    "className": "recommendation__icon"
  }), React.createElement("div", {
    "className": "recommendation__icon__text"
  }, recommendationKey && i18n("presentations:labels." + recommendationKey)))), React.createElement("div", {
    "className": "recommendation__text"
  }, i18n('presentations:default_content.recommendation_description')));
};

GPSDescription = function(arg) {
  var i18n;
  i18n = arg.i18n;
  return React.createElement("div", {
    "className": "recommendation__description"
  }, React.createElement("div", {
    "className": "recommendation__text"
  }, i18n('presentations:default_content.gps_description')));
};

AdditionalGuidanceDescription = function(arg) {
  var i18n;
  i18n = arg.i18n;
  return React.createElement("div", {
    "className": "recommendation__description"
  }, React.createElement("div", {
    "className": "recommendation__text"
  }, i18n('presentations:default_content.additional_guidance_description')));
};

RecommendationSection = createReactClass({
  displayName: "RecommendationSection",
  propTypes: {
    intervention: string.isRequired,
    comparison: string.isRequired,
    recommendation: string.isRequired,
    documentType: oneOf(['regular', 'gps', 'additional-guidance'])
  },
  getDefaultProps: function() {
    return {
      documentType: 'regular'
    };
  },
  mixins: [CustomRenderMixin, Translation('')],
  render: function() {
    var comparison, documentType, intervention, recommendation, recommendationKey, recommendationLabel, ref2, title;
    ref2 = this.props, intervention = ref2.intervention, comparison = ref2.comparison, recommendation = ref2.recommendation, documentType = ref2.documentType;
    recommendationLabel = mapRecommendationToLabel(recommendation);
    recommendationKey = mapRecommendationToKey(recommendation);
    title = (function() {
      switch (documentType) {
        case 'gps':
          return this.i18n('presentations:good_practice_statement');
        case 'additional-guidance':
          return this.i18n('presentations:additional_guidance');
        default:
          return this.i18n('presentations:recommendation_strength');
      }
    }).call(this);
    return React.createElement("div", null, React.createElement("h2", null, title), React.createElement("div", {
      "className": "recommendation"
    }, React.createElement("h2", {
      "className": "recommendation__title"
    }, recommendationLabel && recommendationLabel !== 'either' && this.i18n("presentations:labels." + recommendationLabel, {
      intervention: intervention
    })), ((function() {
      switch (documentType) {
        case 'gps':
          return React.createElement(GPSDescription, {
            "i18n": this.i18n
          });
        case 'additional-guidance':
          return React.createElement(AdditionalGuidanceDescription, {
            "i18n": this.i18n
          });
        default:
          return React.createElement(RecommendationDescription, {
            "i18n": this.i18n,
            "recommendationKey": recommendationKey
          });
      }
    }).call(this))));
  }
});

module.exports = RecommendationSection;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var LngContext, WhoIsThisForSection, useContext;

useContext = React.useContext;

LngContext = __webpack_require__(9);

WhoIsThisForSection = function(arg) {
  var additionalFields, language, section, sectionClasses, sectionContent;
  section = arg.section;
  language = useContext(LngContext);
  additionalFields = section.getIn(['parts', 'whoIsThisFor', 'additionalFields'], Immutable.List());
  sectionContent = section.getIn(['parts', 'whoIsThisFor', 'content']);
  sectionClasses = classNames('who-is-this-for-section', {
    'text-rtl': language === 'fa' || language === 'ar'
  });
  return React.createElement("div", {
    "className": sectionClasses
  }, React.createElement("h2", null, section.get('name')), React.createElement("ul", null, (!_.isEmpty(sectionContent) ? React.createElement("li", null, sectionContent) : void 0), additionalFields.map(function(field, key) {
    if (!_.isEmpty(field.get('content'))) {
      return React.createElement("li", {
        "key": key
      }, field.get('content'));
    }
  })));
};

module.exports = WhoIsThisForSection;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var GdtEditor, InsertedGdtTable, RecommendationHeader, ReferenceCitation, Translation, bool, createReactClass, editorUtils, instanceOf, object, oneOf, ref, string;

Translation = __webpack_require__(4);

GdtEditor = window.Editor.Editor;

InsertedGdtTable = window.Editor.InsertedGdtTable;

ReferenceCitation = window.Editor.ReferenceCitation;

editorUtils = window.Editor.EditorUtils;

ref = __webpack_require__(1), string = ref.string, instanceOf = ref.instanceOf, oneOf = ref.oneOf, object = ref.object, bool = ref.bool;

createReactClass = __webpack_require__(0);

RecommendationHeader = createReactClass({
  displayName: "RecommendationHeader",
  propTypes: {
    customBlockMapEntries: object,
    customEntityRenderers: object,
    displayContext: oneOf(['default', 'DBEP']).isRequired,
    presentationData: instanceOf(Immutable.Map).isRequired,
    presentationName: string,
    presentationType: string.isRequired,
    references: instanceOf(Immutable.List),
    showRecommendationHeader: bool
  },
  mixins: [Translation('')],
  getDefaultProps: function() {
    return {
      customBlockMapEntries: {},
      customEntityRenderers: {},
      references: Immutable.List(),
      showRecommendationHeader: true
    };
  },
  getInitialState: function() {
    return {
      editingRecommendation: false
    };
  },
  getEditorEl: function(el) {
    return this.gdtEditor = el;
  },
  getSignClassName: function() {
    var presentationType, ref1, selectedOption;
    ref1 = this.props, presentationType = ref1.presentationType, selectedOption = ref1.selectedOption;
    return classNames('sign', presentationType, {
      'strongly-recommended-for': selectedOption === 'recommend' || selectedOption === 'cover' || selectedOption === 'implement',
      'strongly-recommended-against': selectedOption === 'recommend_against' || selectedOption === 'do_not_cover' || selectedOption === 'do_not_implement',
      'conditional-recommended-for': selectedOption === 'suggest' || selectedOption === 'restricted_coverage' || selectedOption === 'implement_with_evaluation',
      'conditional-recommended-against': selectedOption === 'suggest_against' || selectedOption === 'cover_with_evidence' || selectedOption === 'postpone',
      'conditional-either': selectedOption === 'suggest_either' || selectedOption === 'cover_with_price' || selectedOption === 'conduct_pilot_study'
    });
  },
  saveContent: function() {
    var presentationType;
    presentationType = this.props.presentationType;
    return this.props.actions.updateRecommendationContent(presentationType, this.gdtEditor.getEditorContent());
  },
  handlePresentationNameChange: function(evt) {
    return this.props.actions.updatePatientsPresentationName(evt.target.value);
  },
  componentWillReceiveProps: function(nextProps) {
    var hasContentChanged, ref1;
    if (this.gdtEditor == null) {
      return;
    }
    hasContentChanged = _.isString(this.props.content) ? this.props.content !== nextProps.content : this.props.content && nextProps.content ? !((ref1 = this.props.content) != null ? ref1.equals(nextProps.content) : void 0) : false;
    if (hasContentChanged) {
      return this.gdtEditor.resetContent(nextProps.content);
    }
  },
  toggleRecommendationEdit: function() {
    var newEditingState;
    newEditingState = !this.state.editingRecommendation;
    return this.setState({
      editingRecommendation: newEditingState
    });
  },
  saveRecommendation: function() {
    this.saveContent();
    return this.toggleRecommendationEdit();
  },
  renderRecommendationEditControl: function() {
    var cls, editingRecommendation;
    if (!this.props.isEditable) {
      return null;
    }
    editingRecommendation = this.state.editingRecommendation;
    cls = classNames('recommendation-edit-toggle', {
      save: editingRecommendation,
      edit: !editingRecommendation
    });
    return React.createElement("button", {
      "className": cls,
      "onClick": (editingRecommendation ? this.saveRecommendation : this.toggleRecommendationEdit)
    });
  },
  getReferenceCitationDecorator: function() {
    return {
      strategy: editorUtils.findTextByEntityType('REFERENCE'),
      component: ReferenceCitation,
      props: {
        references: this.props.references,
        styles: {
          background: "#005A78"
        }
      }
    };
  },
  _getCustomEntityRenderers: function() {
    return {
      'GDT_TABLE': function(Editor) {
        return {
          component: InsertedGdtTable,
          editable: false,
          props: {
            focusEditor: Editor.focus,
            updateData: this.updateEntityData,
            isEditing: Editor.state.isEditing
          }
        };
      }
    };
  },
  render: function() {
    var editingRecommendation, recommendationContentClass, recommendationText, signClassnames;
    signClassnames = this.getSignClassName();
    editingRecommendation = this.state.editingRecommendation;
    recommendationContentClass = classNames('recommendation-content', {
      editing: editingRecommendation
    });
    recommendationText = !_.isEmpty(this.props.selectedOption) ? this.i18n("presentations:recommendations." + this.props.selectedOption) : "";
    return React.createElement("div", {
      "className": 'recommendation-header'
    }, (this.props.presentationType === 'patients' && this.props.displayContext !== 'DBEP' ? React.createElement("div", {
      "className": 'recommendation-header__section presentation-name'
    }, React.createElement("div", {
      "className": 'title-text'
    }, this.i18n('presentations:presentation_name')), React.createElement("div", {
      "className": "presentation-name_input"
    }, React.createElement("input", {
      "onChange": this.handlePresentationNameChange,
      "placeholder": this.i18n('presentations:placeholders.presentation_name'),
      "type": 'text',
      "value": this.props.presentationName,
      "onBlur": this.props.actions.save,
      "readOnly": !this.props.isEditable
    }))) : void 0), React.createElement("div", {
      "className": "recommendation-header__section recommendation"
    }, React.createElement("div", {
      "className": 'title-text'
    }, this.i18n('presentations:recommendation')), React.createElement("div", {
      "className": recommendationContentClass
    }, (this.props.showRecommendationHeader && !editingRecommendation ? React.createElement("div", {
      "className": "recommendation-text"
    }, React.createElement("span", {
      "className": signClassnames
    }), React.createElement("span", {
      "className": 'text'
    }, recommendationText.toUpperCase())) : void 0), React.createElement(GdtEditor, {
      "blockRenderMap": editorUtils.getBlockRenderMap(this.props.customBlockMapEntries),
      "className": this.props.presentationType,
      "customDecorators": this.getReferenceCitationDecorator(),
      "customEntityRenderers": this._getCustomEntityRenderers(),
      "editorContent": this.props.content,
      "readOnly": !editingRecommendation,
      "ref": this.getEditorEl
    }), React.createElement("div", {
      "className": 'clearfix'
    })), this.renderRecommendationEditControl()));
  }
});

module.exports = RecommendationHeader;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = {"actions":{"add":"إضافة","apply":"تطبيق","cancel":"إلغاء"},"additional_guidance":"إرشادات إضافية","buttons":{"cancel":"إلغاء","change_to_auto":"التغيير إلى الإنشاء الأوتوماتيكي","change_to_manual":"التحويل إلى التحرير اليدوي","close_benefits_and_harms":"إغلاق الفوائد والأضرار","close_table":"إغلاق الجدول","confirm":"تأكيد","keep_auto":"إبقاء الإنشاء الاوتوماتيكي","keep_manual":"إبقاء التحرير اليدوي","ok":"موافق","open_table":"إضغط هنا لفتح الجدول","see_benefits_and_harms":"الإطلاع على الفوائد والأضرار بالأرقام","switch_to_auto":"التحوبل إلى إدخال المعلوملت أوتوماتيكياً","switch_to_manual":"التحويل إلى إدخال المعلومات يدوياً"},"default_content":{"additional_guidance_description":"الإرشادات الإضافية هي بيانات غير رسمية قد تساعد الأشخاص على اتخاذ خيارات بشأن صحتهم ورعايتهم الصحية. قد تأتي هذه العبارات من دراسات علمية، ولكن هناك معلومات مفقودة عن هذه الدراسات وعملية تطويرها.","gps_description":"يمكن أن تساعد عبارة التطبيق الجيد الأشخاص عند إتخاذ قرار يتعلق برعايتهم الصحية. يتم إنشاء عبارة التطبيق الجيد بإستخدام عملية محددة ، ولكن بدون خطوة المراجعة المنهجية لجميع الأدلة.","recommendation_description":"يمكن أن تكون التوصية قوية أو مشروطة. عندما تكون التوصية قوية ، سيرغب معظم الناس في اتباعها. عندما تكون التوصية مشروطة ، يرغب غالبية الأشخاص في اتباعها ولكن قد يحتاجون إلى المزيد من المناقشة مع أخصائي الرعاية الصحية أولاً.","speak_with_healthcare_professional_content":"لتحديد ما إذا كان من الأفضل إتباع (التدخل) أو (المقارنة)، يمكنك التحدث مع أخصائي الرعاية الصحية الخاص بك حول شعورك تجاه الأمور التالية:","what_you_can_do_content":"سيكون من المهم بالنسبة لك التحدث مع أخصائي الرعاية الصحية الخاص بك لتقرير ما إذا كان لديك (المرض)، وما يعني هذا لك.","why_this_recommendation_content":"تقترح هذه التوصية (الفعل إستخدام/ عدم إستخدام) (التدخل) لأن إجمالي (الفوائد/ الأضرار) (قد تكون أكثر/ قد تكون أقل) من (أخذ / عدم أخذ) (التدخل)"},"editor":{"collapse_table":"تصغير الجدول","expand_table":"توسيع الجدول","labels":{"ul":"واجهه المستخدم"},"open_table_in_new_window":"فتح الجدول في نافذة جديدة","outcome":"نتيجة","outcomes":"النتائج","table":"جدول"},"good_practice_statement":"عبارة تطبيق جيد","labels":{"conditional":"مشروط","conditional_against":"مشروط ضد__intervention__","conditional_for":"مشروط تجاه__intervention__","either":"إما","strong":"قوي","strong_against":"قوي ضد__intervention__","strong_for":"قوي تجاه__intervention__"},"messages":{"switch_to_auto":"ال __sectionName__ تم تعديله يدوياً.<br> يمكنك العودة للتعديل الأوتوماتيكي ل __sectionName__ .<br> إذا إخترت التعديل الأوتوماتيكي، سيتم تجاهل أي تعديل يدوي قمت به في  __sectionName__.","switch_to_manual":"ال__sectionName__ تم إنشاؤه أوتوماتيكياً.<br> يمكنك تعديل __sectionName__ بنفسك. <br> إذا إخترت تعديله يدوياً، فلن يعود من الممكن تغييره أوتوماتيكياً بعد ذلك."},"placeholders":{"presentation_name":"إسم العرض"},"presentation_name":"اسم العرض","recommendation":"توصية","recommendation_strength":"قوة التوصية","recommendations":{"conduct_pilot_study":"إجراء دراسة تجريبية للخيار","cover":"تغطية","cover_with_evidence":"تغطية مع تطوير الأدلة","cover_with_price":"تغطية مع التفاوض على السعر","do_not_cover":"لا تغطي","do_not_implement":"لا تنفذ الخيار","implement":"تنفيذ الخيار","implement_with_evaluation":"طبق الخيار مع تقييم النتيجة/الأثر","postpone":"تأجيل القرار","recommend":"نوصي بإستخدام التدخل","recommend_against":"نوصي ضد إستخدام التدخل أو مع إستخدام المقارنة","restricted_coverage":"تغطية محدودة","suggest":"نقترح إستخدام التدخل","suggest_against":"نقترح ضد إستخدام التدخل أو مع إستخدام المقارنة","suggest_either":"نوصي بإستخدام التدخل أو المقارنة","why_this_recommendation":"لماذا __recommendation__"},"section_titles":{"for_decision":"__sectionName__للقرار","for_recommendation":"__sectionName__ للتوصية","related_recommendations":"توصيات مرتبطة"},"titles":{"add_item":"إضافة مادة","add_topic":"إضافة موضوع","publicationDate":"تاريخ النشر","remove":"إزالة"}}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = {"actions":{"add":"přidat","apply":"Použít","cancel":"Zrušit"},"additional_guidance":"Dodatečné pokyny","buttons":{"cancel":"Zrušit","change_to_auto":"Změnit na automatické generování","change_to_manual":"Změnit na ruční upravování","close_benefits_and_harms":"Zavřít přínosy a rizika","close_table":"zavřít tabulku","confirm":"Potvrdit","keep_auto":"Ponechat automatické generování","keep_manual":"Ponechat ruční upravování","ok":"Ok","open_table":"pro otevření tabulky klikněte zde","see_benefits_and_harms":"Zobrazit přínosy a rizika podle čísel","switch_to_auto":"přepnout na automatické","switch_to_manual":"přepnout na ruční"},"default_content":{"additional_guidance_description":"Dodatečné pokyny jsou neformální tvrzení, která mohou pomoci pacientům při rozhodování o jejich zdraví a zdravotní péči. Tato tvrzení mohou vycházet ze studií, avšak bližší informace o těchto studiích a průběhu jejich tvorby chybí.","gps_description":"Doporučení dobré praxe může pomoci pacientům při rozhodování o jejich zdravotní péči. Doporučení dobré praxe jsou vytvářena specifickým postupem, který však neobsahuje systematické shromažďování veškerých dostupných důkazů.","recommendation_description":"Doporučení může být silné, nebo podmíněné. Pokud je doporučení silné, většina osob se jím bude chtít řídit. Pokud je doporučení podmíněné, většina osob se jím bude chtít řídit, avšak možná se nejprve budou chtít poradit se zdravotnickým pracovníkem.","speak_with_healthcare_professional_content":"Chcete-li se rozhodnout, zda je pro vás lepší (intervence), nebo (komparace), můžete se poradit se zdravotnickým pracovníkem o následujícím:","what_you_can_do_content":"Mohlo by pro vás být důležité se poradit se zdravotnickým pracovníkem, zda máte (onemocnění) a co to pro Vás znamená.","why_this_recommendation_content":"Toto doporučení navrhuje (provádět/neprovádět) (intervenci), protože celkové (přínosy/rizika) (mohou být větší/menší) než pokud by (intervence) (byla/nebyla provedena)."},"editor":{"collapse_table":"Sbalit tabulku","expand_table":"Rozbalit tabulku","labels":{"ul":"Ul"},"open_table_in_new_window":"Otevřít tabulku v novém okně","outcome":"Výstup","outcomes":"Výstupy","table":"Tabulka"},"good_practice_statement":"Doporučení dobré praxe","labels":{"conditional":"podmíněné","conditional_against":"Podmíněné doporučení proti __intervention__","conditional_for":"Podmíněné doporučení pro __intervention__","either":"buď","strong":"silné","strong_against":"Silné doporučení proti __intervention__","strong_for":"Silné doporučení pro __intervention__"},"messages":{"switch_to_auto":"Název __sectionName__ byl upraven ručně.<br> Můžete se vrátit k automatickému generování názvu  __sectionName__.<br> Pokud se rozhodnete pro automatické generování, ruční změny názvu __sectionName__, které jste dosud provedli, budou zahozeny. ","switch_to_manual":"Název __sectionName__ byl vygenerován automaticky. <br>Můžete upravit název __sectionName__ ručně.<br> Pokud se ho rozhodnete upravit ručně, už nebude více automaticky měněn."},"placeholders":{"presentation_name":"Název prezentace..."},"presentation_name":"Název prezentace","recommendation":"Doporučení","recommendation_strength":" Síla doporučení","recommendations":{"conduct_pilot_study":"Provést pilotní studii o této variantě","cover":"Pokrýt","cover_with_evidence":"Pokrýt tvorbou důkazů","cover_with_price":"Pokrýt vyjednáváním o ceně","do_not_cover":"Nepokrývat","do_not_implement":"Neimplementovat tuto variantu","implement":"Implementovat tuto variantu","implement_with_evaluation":"Implementovat variantu s hodnocením dopadu","postpone":"Odložit rozhodnutí","recommend":"Doporučujeme intervenci","recommend_against":"Doporučujeme neprovádět intervenci nebo provádět komparaci","restricted_coverage":"Omezené pokrytí","suggest":"Navrhujeme intervenci","suggest_against":"Navrhujeme neprovádět intervenci nebo provádět komparaci","suggest_either":"Navrhujeme provádět buď intervenci nebo komparaci","why_this_recommendation":"Proč __recommendation__"},"section_titles":{"for_decision":"__sectionName__pro rozhodnutí","for_recommendation":"__sectionName__ pro doporučení","related_recommendations":"Související doporučení"},"titles":{"add_item":"Přidat položku","add_topic":"Přidat téma","publicationDate":"Datum zveřejnění","remove":"Odstranit"}}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = {"actions":{"add":"hinzufügen","apply":"Übernehmen","cancel":"Abbrechen"},"additional_guidance":"zusätzliche Informationen","buttons":{"cancel":"Abbrechen","change_to_auto":"In die automatische Erstellung wechseln","change_to_manual":"Zu manueller Bearbeitung wechseln","close_benefits_and_harms":"Nutzen und Schäden schließen","close_table":"Tabelle schließen","confirm":"bestätigen","keep_auto":"Automatische Erstellung beibehalten","keep_manual":"Manuelle Bearbeitung beibehalten","ok":"OK","open_table":"Klicken Sie hier, um die Tabelle zu öffnen","see_benefits_and_harms":"Nutzen und Schäden in Zahlen anzeigen","switch_to_auto":"In den automatischen Modus wechseln","switch_to_manual":"Zu manuell wechseln"},"default_content":{"additional_guidance_description":"Zusätzliche Orientierungshilfen sind informelle Aussagen, die helfen können, Entscheidungen über die eigene Gesundheit und Gesundheitsversorgung zu treffen. Diese Aussagen könnten aus Studien stammen, es fehlen aber Informationen über die Quellen und den Entwicklungsprozess.","gps_description":"Eine Erklärung nach \"Good Practice\"-Kriterien kann dabei helfen, eine Gesundheitsentscheidung zu treffen. Erklärungen zur guten Praxis werden nach einem bestimmten Verfahren erstellt, jedoch ohne eine systematische Überprüfung der wissenschaftlichen Evidenz.","recommendation_description":"Eine Empfehlung kann stark oder bedingt ausfallen. Einer starken Empfehlung wird man in der Regel folgen. Das gilt auch für eine bedingten Empfehlung, allerdings ist es hier besonder wichtig, mit der Ärztin oder dem Arzt über die möglichen Vorteile und Risiken zu sprechen.","speak_with_healthcare_professional_content":"Um Ihnen die Entscheidung zwischen (intervention) oder (comparison) zu erleichtern, können Sie mit Ihrer Ärztin oder Ihrem Arzt folgende Fragen besprechen:","what_you_can_do_content":"Es kann eine wichtige Hilfe sein, mit Ihrem Arzt oder ihrer Ärztin darüber zu sprechen, ob Sie (disease) haben und was das für Sie bedeutet.","why_this_recommendation_content":"Die Empfehlung empfiehlt (action as use/ not use) (intervention), weil die (benefits/ harms) insgesamt (may be greater/ may be smaller) sind, als (having/ not having) (intervention)"},"editor":{"collapse_table":"Tabelle einklappen","expand_table":"Tabelle ausklappen","labels":{"ul":"UI"},"open_table_in_new_window":"Tabelle in neuem Fenster öffnen","outcome":"Endpunkt","outcomes":"Endpunkte","table":"Tabelle"},"good_practice_statement":"Good-Practice-Erklärung ","labels":{"conditional":"bedingt","conditional_against":"bedingt gegen__intervention__","conditional_for":"bedingt für__intervention__","either":"beides","strong":"stark","strong_against":"stark gegen__intervention__","strong_for":"stark für __intervention__"},"messages":{"switch_to_auto":"Der Titel wurde manuell bearbeitet.<br>Sie können zur automatischen Erstellung des__sectionName__zurückkehrern.<br> Wenn Sie die automatische Erstellung auswählen, gehen alle bisherigen manuellen Änderungen des__sectionName__verloren.","switch_to_manual":"Der__sectionName__wurde automatisch erstellt.<br>Sie können den__sectionName__selbst bearbeiten.<br> Wenn Sie sich für die manuelle Bearbeitung entscheiden, wird er nicht mehr automatisch verändert."},"placeholders":{"presentation_name":"Name der Präsentation..."},"presentation_name":"Name der Präsentation","recommendation":"Empfehlung","recommendation_strength":"Empfehlungsstärke","recommendations":{"conduct_pilot_study":"Pilotstudie zur Option durchführen","cover":"Kostenübernahme","cover_with_evidence":"Kostenübernahme unter Berücksichtigung der Weiterentwicklung der Evidenz","cover_with_price":"Kostenübernahme mit Verhandlung des Preises","do_not_cover":"Keine Kostenübernahme ","do_not_implement":"Option nicht implementieren","implement":"Option implementieren","implement_with_evaluation":"Option mit einer Wirkungsbewertung implementieren ","postpone":"Entscheidung verschieben","recommend":"Wir empfehlen diese Intervention","recommend_against":"Unsere Empfehlung ist gegen die Intervention oder für die Vergleichsbehandlung","restricted_coverage":"Begrenzte Kostenübernahme","suggest":"Wir empfehlen die Intervention","suggest_against":"Unsere Empfehlung ist gegen die Intervention oder für die Vergleichsbehandlung","suggest_either":"Bevorzugt weder die Intervention noch die Kontrollintervention","why_this_recommendation":"Warum __recommendation__"},"section_titles":{"for_decision":"__sectionName__für die Entscheidung","for_recommendation":"__sectionName__für die Empfehlung","related_recommendations":"verwandte Empfehlungen"},"titles":{"add_item":"Element hinzufügen","add_topic":"Thema hinzufügen ","publicationDate":"Veröffentlichungsdatum","remove":"Entfernen"}}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = {"messages":{"switch_to_manual":"The __sectionName__ was generated automatically.<br>You can edit the __sectionName__ yourself.<br> If you choose to edit it manually, it will no longer be automatically changed.","switch_to_auto":"The __sectionName__ was edited manually.<br>You can go back to automatic generation of the __sectionName__.<br> If you choose auto-generation, any manual changes of the __sectionName__ you've made so far, will be discarded."},"buttons":{"ok":"Ok","cancel":"Cancel","confirm":"Confirm","switch_to_manual":"switch to manual","switch_to_auto":"switch to auto","keep_auto":"Keep auto-generation","keep_manual":"Keep manual editing","change_to_auto":"Change to auto-generation","change_to_manual":"Change to manual editing","see_benefits_and_harms":"See benefits and harms by numbers","close_benefits_and_harms":"Close benefits and harms","open_table":"click here to open table","close_table":"close table"},"recommendations":{"recommend_against":"We recommend against the intervention or for the comparison","suggest_against":"We suggest against the intervention or for the comparison","suggest_either":"We suggest either the intervention or the comparison","suggest":"We suggest the intervention","recommend":"We recommend the intervention","do_not_cover":"Do not cover","cover_with_evidence":"Cover with evidence development","cover_with_price":"Cover with price negotiation","restricted_coverage":"Restricted coverage","cover":"Cover","conduct_pilot_study":"Conduct a pilot study of the option","do_not_implement":"Do not implement the option","postpone":"Postpone the decision","implement_with_evaluation":"Implement the option with an impact evaluation","implement":"Implement the option","why_this_recommendation":"Why __recommendation__"},"titles":{"add_topic":"Add topic","add_item":"Add item","remove":"Remove","publicationDate":"Publication date"},"section_titles":{"related_recommendations":"Related recommendation(s)","for_recommendation":" __sectionName__ for the recommendation","for_decision":"__sectionName__ for the decision"},"labels":{"strong":"strong","conditional":"conditional","either":"either","conditional_against":"Conditional against __intervention__","conditional_for":"Conditional for __intervention__","strong_against":"Strong against __intervention__","strong_for":"Strong for __intervention__"},"editor":{"labels":{"ul":"Ul"},"table":"Table","outcome":"Outcome","outcomes":"Outcomes","collapse_table":"Collapse table","expand_table":"Expand table","open_table_in_new_window":"Open table in new window"},"actions":{"cancel":"Cancel","apply":"Apply","add":"add"},"placeholders":{"presentation_name":"Presentation name..."},"presentation_name":"Name of presentation","recommendation":"Recommendation","good_practice_statement":"Good practice statement","additional_guidance":"Additional guidance","recommendation_strength":"Recommendation strength","default_content":{"why_this_recommendation_content":"This recommendation suggests (action as use/ not use) (intervention) because the overall (benefits/ harms) (may be greater/ may be smaller) than (having/ not having) (intervention)","what_you_can_do_content":"It might be important for you to talk with your health care professional to determine if you have (disease) and what it means for you.","speak_with_healthcare_professional_content":"To decide whether it is better to have (intervention) or (comparison), you can talk with your health care professional about how you feel about following things:","recommendation_description":"A recommendation can be strong or conditional. When a recommendation is strong, most people will want to follow it. When a recommendation is conditional, the majority of people want to follow it, but they may want to talk with their health care professional first.","gps_description":" A good practice statement can help people make a choice about their health care. Good practice statements are created using a specific process, but without the step of systematic reviewing of all of the evidence.","additional_guidance_description":"Additional guidance are informal statements that might be able to help people make choices about their health and health care. These statements might come from studies, but there is information missing concerning the studies and development process."}}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = {"actions":{"add":"Agregar ","apply":"Aplicar ","cancel":"Cancelar "},"additional_guidance":"Información adicional","buttons":{"cancel":"Cancelar","change_to_auto":"El texto fue editado manualmente. Usted puede volver a la generación automática, si lo hace cualquier cambio manual del título que haya hecho hasta ahora, se perderá.","change_to_manual":"Cambiar a editar manualmente","close_benefits_and_harms":"Beneficios y daños","close_table":"Cerrado","confirm":"Los Términos de Servicio han cambiado desde la última vez que usted inició sesión. <br>Por favor confirme que acepta nuestro Términos de Servicio actuales.","keep_auto":"El texto fue editado manualmente. Usted puede volver a la generación automática, si lo hace cualquier cambio manual del título que haya hecho hasta ahora, se perderá.","keep_manual":"Cambiar a editar manualmente","ok":"Aceptar","open_table":"Haga clic aquí para ver el proyecto exportado.","see_benefits_and_harms":"Beneficios y daños","switch_to_auto":"El texto fue editado manualmente. Usted puede volver a la generación automática, si lo hace cualquier cambio manual del título que haya hecho hasta ahora, se perderá.","switch_to_manual":"Cambiar a editar manualmente el título de la tabla"},"default_content":{"additional_guidance_description":"La información orientadora adicional son declaraciones informales que podrían ayudar a las personas a tomar decisiones sobre su salud y su atención médica. Estas declaraciones pueden provenir de estudios, sinembargo se realizan por que falta información sobre los estudios y el proceso de desarrollo.","gps_description":"Un enunciado de buena práctica puede ayudar a las personas a tomar una decisión sobre su atención médica. Los enunciados de buena práctica se crean usando un proceso específico que no necesariamente incluye la revisión sistemática de toda la evidencia.","recommendation_description":"Una recomendación puede ser fuerte o condicional. Cuando una recomendación es fuerte, la mayoría de la gente querrá seguirla. Cuando una recomendación es condicional, la mayoría de las personas quieren seguirla, pero es posible que deseen hablar primero con el profesional de la salud asignado a su cuidado.","speak_with_healthcare_professional_content":"GRADEpro / GDT incluye un mecanismo para preparar y obtener una vista previa en las aplicaciones de dispositivos móviles a partir de las guías producidas con GRADEpro / GDT. Las aplicaciones móviles siguen la presentación diseñada para profesionales de la salud que fue probada en el proyecto DECIDE del grupo de trabajo GRADE, respaldado por la UE.<br><br>Usted puede obtener una vista previa de su proyecto como aplicación móvil en cualquier momento al hacer clic en \"Producir aplicación móvil\". Nos comunicaremos con usted para completar el proceso que puede requerir modificaciones adicionales, decisiones sobre la publicación en la App Store, etc.","what_you_can_do_content":"Puede ser importante para usted hablar con el profesional de salud que lo atiende, para determinar si usted tiene (enfermedad) y esto qué significa para usted en terminos de salud.","why_this_recommendation_content":"Es probable que la guía no pueda abordar todas las preguntas identificadas como potencialmente relevantes. Algunas preguntas pueden tener mayor prioridad que otras. Por ejemplo, pueden abordar un problema más frecuente y/o más grave, o puede haber una mayor incertidumbre sobre la respuesta a la pregunta entre los usuarios objetivo. Teniendo en cuenta el alcance del documento, <strong>proporcione una calificación para cada una de las siguientes preguntas</strong>. Utilice una escala de 1 a 9 puntos que indique la importancia que tiene la pregunta para ser abordada en este documento y/o respondida con decisiones/recomendaciones.<strong> \"1\" significa la prioridad más baja, \"9\" significa la prioridad más alta."},"editor":{"collapse_table":"Desplegar tabla","expand_table":"Expandir","labels":{"ul":"La barra de herramientas le permite: <span class='icon settings'> manejar la configuración y activar/desactivar módulos,<span class='icon feedback'> enviarnos retroalimnetación, </span> obtener ayuda y ver nuevas opciones.</li>"},"open_table_in_new_window":"Abrir tabla en una nueva ventana","outcome":"Desenlace","outcomes":"Desenlace","table":"Tabla"},"good_practice_statement":"Enunciado de buena práctica","labels":{"conditional":"Condicional","conditional_against":"Recomendación condicional en contra de la intervención","conditional_for":"Recomendación condicional para __int__","either":"Ni negativo ni positivo","strong":"Fuerte","strong_against":"Recomendación fuerte en contra de __int__","strong_for":"Recomendación fuerte para __int__"},"messages":{"switch_to_auto":"El título fue generado automáticamente.<br>Puede ser editado por usted mismo.<br> Si decide editarlo manualmente, no volverá a cambiarse de forma automática.  ","switch_to_manual":"El GDT genera automáticamente el título de una tabla de Resumen de hallazgos (SoF). Sin embargo, el título a veces puede necesitar una edición adicional. Si presiona Aceptar, podrá editar manualmente el título, pero este campo ya no se cambiará automáticamente cuando edite la pregunta de perfil."},"placeholders":{"presentation_name":"Presentación"},"presentation_name":"Presentaciones","recommendation":"Recomendaciones","recommendation_strength":"Fuerza de la recomendación","recommendations":{"conduct_pilot_study":"Realizar un estudio piloto de __int__","cover":"No cubrir","cover_with_evidence":"Cubrir con desarrollo de evidencia","cover_with_price":"Cubrir con negociación de precio","do_not_cover":"No cubrir","do_not_implement":"No implementar","implement":"No implementar la opción","implement_with_evaluation":"Implementar la opción con una evaluación de impacto","postpone":"Posponer","recommend":"Recomendamos en contra de la intervención o a favor de la comparación","recommend_against":"Recomendamos en contra de la intervención o a favor de la comparación","restricted_coverage":"Cobertura restringida","suggest":"Sugerimos la intervención","suggest_against":"Recomendamos en contra de la intervención o a favor de la comparación","suggest_either":"Sugerimos la intervención o la comparación","why_this_recommendation":"¿Por qué esta recomendación?"},"section_titles":{"for_decision":"__sectionName__ para la decisión","for_recommendation":"Proceda a la sección de RECOMENDACIONES","related_recommendations":"Recomendación(es) relacionada(s) "},"titles":{"add_item":"Agregar","add_topic":"Identificación del público objetivo y selección de temas","publicationDate":"Fecha de publicación","remove":"Eliminar"}}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = {"actions":{"add":"اضافه کردن","apply":"درخواست کردن","cancel":"لغو"},"additional_guidance":"راهنمایی بیشتر","buttons":{"cancel":"لغو","change_to_auto":"به تولید خودکار تغییر کن","change_to_manual":"به ویرایش دستی تغییر کن","close_benefits_and_harms":"فواید و زیان های نزدیک","close_table":"جدول را ببند","confirm":"تایید","keep_auto":"تولید خودکار را نگه دار","keep_manual":"ویرایش دستی را نگه دار","ok":"بسیار خوب","open_table":"بر روی اینجا کلیک کنید تا جدول باز شود","see_benefits_and_harms":"فواید و زیان ها را با اعداد ببینید","switch_to_auto":"به خودکار تغییر کن","switch_to_manual":"به دستی تغییر کن"},"default_content":{"additional_guidance_description":"راهنمایی های بیشتر، توضیحات غیر رسمی هستند که ممکن است به افراد در انتخاب در خصوص سلامت و مراقبت از سلامت خود کمک کنند. این توضیحات ممکن است حاصل از مطالعات مختلف باشند، اما نقص اطلاعاتی در خصوص مطالعات و روند پیشرفت وجود دارد.","gps_description":"یک گزاره خط مشی خوب می تواند به مردم کمک کند تا بتوانند در رابطه با سلامتی خود تصمیم گیری کنند. گزاره های خط مشی خوب با فرایند مخصوصی ایجاد می شوند، اما این موارد بدون انجام مرحله مرور نظام مند بر روی تمامی شواهد صورت می گیرند.","recommendation_description":"یک توصیه می­تواند قوی یا مشروط باشد. هنگامی که توصیه­ای قوی است، بیشتر مردم می­خواهند از آن پیروی کنند. زمانی که توصیه­ای مشروط است، بیشتر مردم می خواهند آن را دنبال کنند، اما پیش از آن ممکن است نیاز به مشورت بیشتری با درمان گر متخصص خود داشته باشند.","speak_with_healthcare_professional_content":"برای تصمیم گیری در این خصوص که بهتر است (مداخله) یا (مقایسه) را داشته باشید، می توانید با درمان گر متخصص خود در رابطه با احساس خود در این موارد صحبت کنید","what_you_can_do_content":"ممکن است برایتان اهمیت داشته باشد که با درمان گر متخصص خود صحبت کنید تا وجود (بیماری) در شما تایید شود و مشخص شود که این بیماری برای شما چه معنایی دارد.","why_this_recommendation_content":"این توصیه (اقدام به مصرف/عدم مصرف) (مداخله) را پیشنهاد می کند؛ زیرا، (فواید/زیان ها) کلی (ممکن است بیشتر/کمتر) از (داشتن/نداشتن) (مداخله) هستند."},"editor":{"collapse_table":"جدول را خلاصه کن","expand_table":"جدول را گسترش بده","labels":{"ul":"Ul"},"open_table_in_new_window":"جدول را در پنجره ای جدید باز کن","outcome":"پیامد","outcomes":"پیامدها","table":"جدول"},"good_practice_statement":"گزاره راهکار خوب","labels":{"conditional":"مشروط","conditional_against":"مشروط در برابر __intervention__","conditional_for":"مشروط برای __intervention__","either":"یا","strong":"قوی","strong_against":"پر قدرت در برابر __intervention__","strong_for":"پر قدرت برای __intervention__"},"messages":{"switch_to_auto":" __sectionName__ به شکل دستی ویرایش شده بود. <br> می توانید به تولید خودکار  __sectionName__ بازگردید. <br> اگر تولید خودکار را انتخاب کنید، هر تغییر دستی مربوط به __sectionName__ را که تا به حال انجام داده اید، نادیده گرفته می شود.","switch_to_manual":"__sectionName__ به شکل خودکار تولید شد. <br> شما می توانید __sectionName__  را خودتان ویرایش کنید. <br>اگر بخواهید که به شکل دستی ویرایش کنید، دیگر به شکل خودکار تغییر نمی کند."},"placeholders":{"presentation_name":"نام ارائه..."},"presentation_name":"نام ارائه","recommendation":"توصیه","recommendation_strength":"قدرت توصیه","recommendations":{"conduct_pilot_study":"یک مطالعه آزمایشی در خصوص گزینه مورد نظر انجام دهید","cover":"پوشش دادن","cover_with_evidence":"با توسعه شواهد پوشش بده","cover_with_price":"قیمت را با مذاکره پنهان کن","do_not_cover":"پوشش نده","do_not_implement":"گزینه مورد نظر را اجرا نکنید","implement":"گزینه مورد نظر را اجرا کنید","implement_with_evaluation":"گزینه را با ارزیابی اثر اجرا کن","postpone":"تصمیم را به تعویق بیندازید","recommend":"ما مداخله را پیشنهاد می کنیم","recommend_against":"ما به مورد مداخله یا مورد مقایسه توصیه نمی کنیم","restricted_coverage":"پوشش محدود شده","suggest":"ما مداخله را پیشنهاد می کنیم","suggest_against":"ما توصیه به عدم استفاده از مداخله یا مورد مقایسه می کنیم","suggest_either":"ما نه مداخله نه مقایسه را توصیه نمی کنیم","why_this_recommendation":"چرا __recommendation__"},"section_titles":{"for_decision":"__sectionName__ برای تصمیم گیری","for_recommendation":" __sectionName__ برای توصیه","related_recommendations":"توصیه (های) مرتبط"},"titles":{"add_item":"آیتم را اضافه کن","add_topic":"موضوع را اضافه کن","publicationDate":"تاریخ انتشار","remove":"حذف کردن"}}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = {"actions":{"add":"ajouter","apply":"Appliquer","cancel":"Annuler"},"additional_guidance":"Conseils supplémentaires","buttons":{"cancel":"Annuler","change_to_auto":"Changer à l'auto-génération","change_to_manual":"Passer à l'édition manuelle","close_benefits_and_harms":"Fermer les avantages et les préjudices","close_table":"table fermée","confirm":"Confirmer","keep_auto":"Garder l'auto-génération","keep_manual":"Garder l'édition manuelle","ok":"D'accord","open_table":"cliquez ici pour ouvrir la table","see_benefits_and_harms":"Voir les avantages et les préjudices en chiffres","switch_to_auto":"passer en mode automatique","switch_to_manual":"passer en mode manuel"},"default_content":{"additional_guidance_description":"Les directives supplémentaires sont des déclarations informelles qui pourraient être en mesure d'aider les gens à faire des choix concernant leur santé et les soins de santé. Ces déclarations peuvent provenir de diverses études, mais il manque des informations concernant les études et le processus de développement.","gps_description":"Une déclaration de bonne pratique peut aider les gens à faire un choix concernant leurs soins de santé. Les déclarations de bonnes pratiques sont créées selon un processus spécifique, mais sans passer par l'étape de revue systématique de toutes les preuves.","recommendation_description":"Une recommandation peut être forte ou conditionnelle. Lorsqu'une recommandation est forte, la plupart des gens voudront la suivre. Lorsqu'une recommandation est conditionnelle, la majorité des gens veulent la suivre, mais il se peut qu'ils doivent d'abord en discuter avec leur professionnel de la santé.","speak_with_healthcare_professional_content":"Pour décider s'il est préférable d'avoir (intervention) ou (comparaison), vous pouvez parler avec votre professionnel de la santé de ce que vous ressentez à propos des points suivants:","what_you_can_do_content":"Il pourrait être important pour vous de parler avec votre professionnel de la santé pour déterminer si vous avez (maladie) et ce que cela signifie pour vous.","why_this_recommendation_content":"Cette recommandation suggère (d'utiliser/de ne pas utiliser) (l'intervention) parce que les (avantages/inconvénients) globaux (peuvent être supérieurs/peuvent être inférieurs) que (d'avoir/de ne pas avoir) (l'intervention)."},"editor":{"collapse_table":"Réduire le tableau","expand_table":"Élargir le tableau","labels":{"ul":"Ul"},"open_table_in_new_window":"Ouvrir la table dans une nouvelle fenêtre","outcome":"Résultat","outcomes":"Résultats","table":"Tableau"},"good_practice_statement":"Déclaration de bonne pratique","labels":{"conditional":"Conditionnel","conditional_against":"Conditionnelle contre __intervention__","conditional_for":"Conditionnelle pour __intervention__","either":"soit","strong":"Fort","strong_against":"Forte contre __intervention__","strong_for":"Forte pour __intervention__"},"messages":{"switch_to_auto":"Le __sectionName__ a été modifié manuellement.<br>Vous pouvez revenir à la génération automatique du __sectionName__.<br> Si vous choisissez la génération automatique, toutes les modifications manuelles du __sectionName__ que vous avez effectuées jusqu'à présent, seront rejetées.","switch_to_manual":"Le __sectionName__ a été généré automatiquement.<br>Vous pouvez modifier vous-même le __sectionName__ .<br> Si vous choisissez de le modifier manuellement, il ne sera plus modifié automatiquement."},"placeholders":{"presentation_name":"Titre de la présentation..."},"presentation_name":"Titre de la présentation","recommendation":"Recommandation","recommendation_strength":"Force de la recommandation","recommendations":{"conduct_pilot_study":"Réaliser une étude préliminaire de l'option","cover":"Couvrir","cover_with_evidence":"Couvrir avec le développement de preuves","cover_with_price":"Couvrir avec une négociation de prix","do_not_cover":"Ne pas couvrir","do_not_implement":"Ne pas mettre en œuvre l'option","implement":"Mettre en œuvre l'option","implement_with_evaluation":"Mettre en œuvre l'option avec une évaluation d'impact","postpone":"Reporter la décision","recommend":"Nous recommandons l'intervention","recommend_against":"Nous recommandons contre l'intervention ou pour la comparaison","restricted_coverage":"Protection limitée","suggest":"Nous suggérons l'intervention","suggest_against":"Nous suggérons contre l'intervention ou pour la comparaison","suggest_either":"Nous suggérons soit l'intervention, soit la comparaison","why_this_recommendation":"Pourquoi __recommendation__"},"section_titles":{"for_decision":"__sectionName__ pour la décision ","for_recommendation":"__sectionName__ pour la recommandation","related_recommendations":"Recommandation(s) connexe(s)"},"titles":{"add_item":"Ajouter un élément","add_topic":"Ajouter un sujet","publicationDate":"Date de publication","remove":"Retirer"}}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = {"actions":{"add":"जोड़े","apply":"लागू","cancel":"रद्द"},"additional_guidance":"अतिरिक्त मार्गदर्शन","buttons":{"cancel":"रद्द कर दें","change_to_auto":"ऑटो-जेनरेशन में बदलें","change_to_manual":"मैन्युअल संपादन में बदलें","close_benefits_and_harms":"लाभ और हानि बंद करें","close_table":"टेबल बंद करें","confirm":"पुष्टि करें","keep_auto":"ऑटो-जेनरेशन रखें","keep_manual":"मैन्युअल संपादन रखें","ok":"ठीक है","open_table":"टेबल खोलने के लिए यहां क्लिक करें","see_benefits_and_harms":"संख्याओं से लाभ और हानि देखें","switch_to_auto":"ऑटो पर स्विच करें","switch_to_manual":"मैनुअल पर स्विच करें"},"default_content":{"additional_guidance_description":"अतिरिक्त मार्गदर्शन अनौपचारिक बयान हैं जो लोगों को उनके स्वास्थ्य और स्वास्थ्य देखभाल के बारे में चयन करने में मदद कर सकते हैं। ये कथन अध्ययनों से आ सकते हैं, लेकिन अध्ययन और विकास प्रक्रिया से संबंधित जानकारी में कमी है।","gps_description":"अच्छा अभ्यास वक्तव्य लोगों को उनकी स्वास्थ्य देखभाल के बारे में चयन करने में मदद कर सकता है। एक विशिष्ट प्रक्रिया का उपयोग करके अच्छे अभ्यास कथन बनाए जाते हैं, लेकिन सभी साक्ष्यों की व्यवस्थित समीक्षा के चरनो के बिना।","recommendation_description":"सिफारिश मजबूत या सशर्त हो सकती है। जब कोई सिफारिश मजबूत होती है, तो ज्यादातर लोग उसका पालन करना चाहेंगे। जब कोई सिफारिश सशर्त होती है, तो अधिकांश लोग इसका पालन करना चाहेंगे, लेकिन हो सकता है कि वे पहले अपने स्वास्थ्य देखभाल पेशेवर से बात करना चाहें।","speak_with_healthcare_professional_content":"यह तय करने के लिए कि (हस्तक्षेप) करना बेहतर है या (तुलना), आप अपने स्वास्थ्य देखभाल पेशेवर से बात कर सकते हैं कि आप निम्नलिखित चीजों के बारे में कैसा महसूस करते हैं:","what_you_can_do_content":"यह निर्धारित करने के लिए कि क्या आपको (बीमारी) है और आपके लिए इसका क्या अर्थ है, आपके लिए अपने स्वास्थ्य देखभाल पेशेवर से बात करना महत्वपूर्ण हो सकता है","why_this_recommendation_content":"THIS TEXT IS UNCLEAR"},"editor":{"collapse_table":"टेबल संक्षिप्त करें","expand_table":"टेबल का विस्तार करें","labels":{"ul":"WORD IS NOT CLEAR TO ME"},"open_table_in_new_window":"टेबल को नई विंडो में खोलें","outcome":"परिणाम","outcomes":"परिणाम","table":"टेबल"},"good_practice_statement":"अच्छा अभ्यास कथन","labels":{"conditional":" सशर्त","conditional_against":"__हस्तक्षेप__ के विरुद्ध सशर्त","conditional_for":"__हस्तक्षेप__ के लिए सशर्त","either":"दोनों में से एक","strong":" मजबूत","strong_against":"__हस्तक्षेप__ के खिलाफ मजबूत","strong_for":"__हस्तक्षेप__ के लिए मजबूत"},"messages":{"switch_to_auto":".","switch_to_manual":"."},"placeholders":{"presentation_name":"प्रस्तुति का नाम..."},"presentation_name":"प्रस्तुति का नाम","recommendation":"सिफ़ारीश","recommendation_strength":"सिफारिश की ताकत","recommendations":{"conduct_pilot_study":"विकल्प का प्रायोगिक अध्ययन करें","cover":"कवर करें","cover_with_evidence":"सबूत के विकास के साथ कवर करें","cover_with_price":"मूल्य वार्ता के साथ कवर करें","do_not_cover":"कवर न करें","do_not_implement":"विकल्प को लागू न करें","implement":"विकल्प लागू करें","implement_with_evaluation":"प्रभाव मूल्यांकन के साथ विकल्प को लागू करें","postpone":"फैसला टालें","recommend":"हम हस्तक्षेप की सिफ़ारिश करते हैं.","recommend_against":"हम हस्तक्षेप के खिलाफ या तुलना के पक्ष में, सिफ़ारिश करते हैं","restricted_coverage":"प्रतिबंधित कवरेज","suggest":"हम हस्तक्षेप का सुझाव देते हैं","suggest_against":"हम हस्तक्षेप के खिलाफ, या तुलना के पक्ष में, सुझाव देते हैं","suggest_either":"हम हस्तक्षेप या तुलना का सुझाव देते हैं","why_this_recommendation":"क्यों __सिफारिश__"},"section_titles":{"for_decision":"__ निर्णय के लिए अनुभाग का नाम","for_recommendation":"__ सिफ़ारिश के लिए अनुभाग का नाम","related_recommendations":"संबंधित सिफारिशें"},"titles":{"add_item":"मद जोड़ें","add_topic":"विषय जोड़ें","publicationDate":"प्रकाशन तिथि","remove":"कृपया निकालें"}}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = {"actions":{"add":"aggiungere","apply":"Applicare","cancel":"Cancellare"},"additional_guidance":"Le guide aggiuntive sono documenti informali che possono aiutare le persone a fare delle scelte relative alla loro salute. Le affermazioni contenute in questi documenti potrebbero provenire da studi, ma mancano informazioni riguardanti gli studi e il processo che ha portato al loro sviluppo.","buttons":{"cancel":"Cancellare","change_to_auto":"Cambiare l'auto-generazione","change_to_manual":"Cambiare in modifica manuale","close_benefits_and_harms":"Benefici e danni","close_table":"Chiudere la tabella","confirm":"Confermare","keep_auto":"Mantenere l'auto-generazione","keep_manual":"Mantenere la modifica manuale","ok":"OK","open_table":"Clicca qui per aprire la tabella","see_benefits_and_harms":"Vedere Benefici e danni attraverso i numeri","switch_to_auto":"Passare ad automatico","switch_to_manual":"Passare a manuale"},"default_content":{"additional_guidance_description":"Le guide aggiuntive sono documenti informali che possono aiutare le persone a fare delle scelte relative alla loro salute. Le affermazioni contenute in questi documenti potrebbero provenire da studi, ma mancano informazioni riguardanti gli studi e il processo che ha portato al loro sviluppo.","gps_description":"Una affermazione di buona pratica può aiutare le persone a fare una scelta in merito alla propria salute. Le affermazioni di buona pratica vengono create utilizzando un processo specifico, ma senza la fase di revisione sistematica di tutte le prove.","recommendation_description":"Una raccomandazione può essere forte o condizionale. Quando la raccomandazione è forte, la maggior parte delle persone vorrà seguirla. Quando la raccomandazione è condizionale, la maggior parte delle persone vorrà seguirla, ma prima vorranno parlarne con il proprio medico.","speak_with_healthcare_professional_content":"Per decidere se sia meglio il'intervento o il confronto, può parlare con il suo medico rispetto a:","what_you_can_do_content":"Sarebbe preferibile che parlasse con il suo medico per capire se è affetto da (malattia) e cosa questo significhi per lei","why_this_recommendation_content":"Questa raccomandazione suggerisce (azioni come usare/non usare) (intervento) perché il bilancio complessivo (benefici/danni) (può essere maggiore/può essere minore) rispetto a (avere/non avere) (l'intervento)"},"editor":{"collapse_table":"Rimpicciolisci la tabella","expand_table":"Espandi la tabella","labels":{"ul":"La barra degli strumenti consente di: <ul calsse = \"icone\"> <li> <classe span= \"setting icone\"> <s/pan> ' gestire le impostazioni e attivare / disattivare moduli, </ span> </ li> <classe span='icona di feedback'> </ span> <span> inviaci un feedback, </ span> </ li> <li> <classe span = 'icona aiuto'> </ span> <span> per ottenere aiuto e verificare nuove funzionalità. </ span> </ li> </ ul>"},"open_table_in_new_window":"Apri la tabella in una nuova finestra","outcome":"Esito","outcomes":"Esito","table":"Tabella"},"good_practice_statement":"Una affermazione di buona pratica può aiutare le persone a fare una scelta in merito alla propria salute. Le affermazioni di buona pratica vengono create utilizzando un processo specifico, ma senza la fase di revisione sistematica di tutte le prove.","labels":{"conditional":"Condizionale","conditional_against":"Raccomandazione condizionale contro __intervention__","conditional_for":"Raccomandazione condizionale relativa a __intervento__","either":"oppure","strong":"Fortemente sospetto","strong_against":"Raccomandazione forte contro __intervention__","strong_for":"Raccomandazione forte a favore di __intervento__"},"messages":{"switch_to_auto":"Il __sectionName__ è stato modificato manualmente. <br> Si può tornare alla generazione automatica del __sectionName__ . <br> Se si sceglie l'auto-generazione, qualsiasi modifica manuale del __sectionName__ fatta fino ad ora sarà perduta.","switch_to_manual":"Il __sectionName__ è stato generato automaticamente.<br> Il __sectionName__ si puo' modificare<br> Se si sceglie di modificarlo manualmente, non sarà più possibile cambiarlo automaticamente"},"placeholders":{"presentation_name":"Nome"},"presentation_name":"Nome","recommendation":"Procedere alla sezione relativa alla RACCOMANDAZIONE","recommendation_strength":"Forza della raccomandazione","recommendations":{"conduct_pilot_study":"Condurre uno studio pilota sull'opzione","cover":"Fornire copertura","cover_with_evidence":"Fornire una copertura con produzione di prove","cover_with_price":"Fornire la copertura con una negoziazione del prezzo","do_not_cover":"Non fornire alcuna copertura","do_not_implement":"Non implementare l'opzione","implement":"Implementare l'opzione","implement_with_evaluation":"Implementare l'opzione con una valutazione di impatto","postpone":"Posticipa la decisione","recommend":"Raccomandiamo l'intervento","recommend_against":"Raccomandiamo a sfavore sia dell'intervento che del confronto","restricted_coverage":"Fornire una copertura con delle restrizioni","suggest":"Si consiglia l'intervento","suggest_against":"Sconsigliamo sia l'intervento che il confronto","suggest_either":"Suggeriamo sia l'intervento che il confronto","why_this_recommendation":"Inviare il modulo di notifica OMS"},"section_titles":{"for_decision":"Section name__ per la decisione","for_recommendation":"Il __sectionName__ è stato modificato manualmente. <br> Si può tornare alla generazione automatica del __sectionName__ . <br> Se si sceglie l'auto-generazione, qualsiasi modifica manuale del __sectionName__ fatta fino ad ora sarà perduta.","related_recommendations":"Raccomandazioni"},"titles":{"add_item":"È inoltre possibile aggiungere o modificare le spiegazioni facendo clic col tasto  destro sulla voce da modificare. Per favore clicchi sul pulsante 'Avanti' per continuare.","add_topic":"Aggiungere un topic","publicationDate":"Data ","remove":"Rimuovere il test di confronto"}}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = {"actions":{"add":"Adicionar","apply":"Aplicar","cancel":"Cancelar"},"additional_guidance":"Orientação adicional","buttons":{"cancel":"Cancelar","change_to_auto":"Mudar para criação automática","change_to_manual":"Mudar para edição manual","close_benefits_and_harms":"Benefícios e riscos","close_table":"Fechar tabela","confirm":" confirme","keep_auto":" Manter criação automática","keep_manual":"Manter edição manual","ok":"Aceitar","open_table":"selecione aqui para abrir a tabela","see_benefits_and_harms":"Ver benefícios e riscos por números","switch_to_auto":"Mudar para automático","switch_to_manual":"mudar para manual"},"default_content":{"additional_guidance_description":"Orientações adicionais são declarações informais que podem ajudar as pessoasa fazer escolhas sobre a sua saúde e os cuidados de saúde. Estas afirmaçõespodem vir de estudos, mas pode faltar informação sobre os estudos e oprocesso de desenvolvimento.","gps_description":"Uma declaração de boas práticas pode ajudar as pessoas a fazer uma escolhasobre os seus cuidados de saúde. As declarações de boas práticas são criadasusando um processo específico, mas sem a etapa de revisão sistemática detodas as evidências.","recommendation_description":"Uma recomendação pode ser forte ou condicional. Quando uma recomendação éforte, a maioria das pessoas vai querer segui-la. Quando uma recomendação écondicional, a maioria das pessoas quer segui-la, mas pode querer conversarprimeiro com o seu profissional de saúde.","speak_with_healthcare_professional_content":"Para decidir o que será melhor ter (intervenção) ou (comparação), poderáfalar com o seu profissional de saúde sobre o que sente sobre os seguintesaspetos:","what_you_can_do_content":"Pode ser importante para si falar com o seu profissional de saúde paradeterminar se tem (doença) e o que isso significa para si","why_this_recommendation_content":"Esta recomendação sugere (ação como usar/não usar) (intervenção) porque emgeral (benefícios/ riscos) (pode ser maior/pode ser menor) do que (ter/nãoter) (intervenção)"},"editor":{"collapse_table":"Recolher tabela","expand_table":"Ampliar tabela","labels":{"ul":"UI"},"open_table_in_new_window":"Abrir tabela numa nova janela","outcome":"Resultado","outcomes":"Resultados","table":"Tabela"},"good_practice_statement":"Declaração de boas práticas","labels":{"conditional":"condicional","conditional_against":"Condicional contra __intervention__","conditional_for":"Condicional para __intervention__","either":"ou","strong":"forte","strong_against":"forte contra __intervention__","strong_for":"Forte para __intervention__"},"messages":{"switch_to_auto":"A __sectionName__ foi editada manualmente.<br> Pode voltar à criaçãoautomatica da__sectionName__.<br> Se escolher a criação automática,quaisquer alterações manuais da __sectionName__ que tenha feito até agoraserão rejeitadas.","switch_to_manual":"A __sectionName__ foi criada automáticamente.<br> Pode editara__sectionName__ .<br> Se optar por editá-la manualmente, deixará de seralterada automaticamente."},"placeholders":{"presentation_name":"Nome da apresentação"},"presentation_name":"Nome da apresentação","recommendation":"Recomendação","recommendation_strength":"Força da recomendação","recommendations":{"conduct_pilot_study":"Realizar um estudo piloto da opção","cover":"Cobrir / Tapar","cover_with_evidence":"Cobertura com o desenvolvimento da evidência","cover_with_price":"Cobertura com negociação de preço","do_not_cover":"Não tapar","do_not_implement":"Não implementar a opção","implement":"Implementar a opção","implement_with_evaluation":"Implementar a opção com avaliação do impacto","postpone":"Adiar a decisão","recommend":"Recomendamos a intervenção","recommend_against":"Recomendamos contra a intervenção ou a favor da comparação","restricted_coverage":"Cobertura limitada","suggest":"Sugerimos a intervenção","suggest_against":"Sugerimos contra a intervenção ou a favor da comparação","suggest_either":"Sugerimos quer a intervenção quer a comparação","why_this_recommendation":"Porquê __recommendation__"},"section_titles":{"for_decision":"__sectionName__ para a decisão","for_recommendation":"__sectionName__ para a recomendação","related_recommendations":"Recomendações relacionadas"},"titles":{"add_item":"Adicionar item","add_topic":"Adicionar tópico","publicationDate":"Data da publicação","remove":"Remover"}}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = {"actions":{"add":"pridať ","apply":"Použiť ","cancel":"Zrušiť "},"additional_guidance":"Dodatočné usmernenie","buttons":{"cancel":"Zrušiť","change_to_auto":"Zmeniť na automatické generovanie ","change_to_manual":"Zmeniť na ručné upravovanie","close_benefits_and_harms":"Zatvoriť prínosy a riziká","close_table":"zatvoriť tabuľku","confirm":"Potvrdiť","keep_auto":"Ponechať automatické generovanie","keep_manual":"Ponechať ručné upravovanie","ok":"Ok","open_table":"kliknite sem pre otvorenie tabuľky","see_benefits_and_harms":"Pozri prínosy a riziká podľa čísiel","switch_to_auto":"prepnúť na automatické","switch_to_manual":"prepnúť na manuálne"},"default_content":{"additional_guidance_description":"Dodatočné rady/ poučenia sú neformálne tvrdenia, ktoré môžu pomôcť ľuďom urobiť rozhodnutie o ich zdraví a zdravotnej starostlivosti.  Tieto tvrdenia môžu vychádzať zo štúdií, avšak chýba v nich informácia týkajúca sa štúdií a procesu ich tvorby. ","gps_description":" Odporúčanie dobrej praxe môže ľuďom pomôcť urobiť rozhodnutie o ich zdravotnej starostlivosti. Odporúčania dobrej praxe sú tvorené s použitím špecifického procesu, ktorý však neobsahuje systematické prehľady všetkých dôkazov. ","recommendation_description":"Odporúčanie môže byť silné alebo podmienené. Keď je odporúčanie silné, väčšina ľudí sa ním bude chcieť riadiť. Keď je odporúčanie podmienené, väčšina ľudí sa ním bude chcieť riadiť, avšak môžu sa najskôr chcieť poradiť so zdravotníckym pracovníkom.","speak_with_healthcare_professional_content":"Ak sa chcete rozhodnúť, či je pre Vás lepšia (intervencia) alebo (porovnanie), môžete sa poradiť s lekárom o nasledujúcich veciach / oblastiach:","what_you_can_do_content":"Mohli by pre Vás byť dôležité porozprávať sa s lekárom, či máte (ochorenie) a čo to pre Vás znamená.","why_this_recommendation_content":"Toto odporúčanie navrhuje (použiť/ nepoužiť) (intervenciu) pretože celkovo (prínosy/ riziká) (môžu byť väčšie/ môžu byť menšie) než pokiaľ by (intervencia) (bola použitá/ nebola použitá)."},"editor":{"collapse_table":"Zbaliť tabuľku","expand_table":"Rozbaliť tabuľku","labels":{"ul":"UI "},"open_table_in_new_window":"Otvoriť tabuľku v novom okne","outcome":"Výstup","outcomes":"Výstupy","table":"Tabuľka"},"good_practice_statement":"Odporúčanie dobrej praxe","labels":{"conditional":"podmienené ","conditional_against":"Podmienené proti_intervention_","conditional_for":"Podmienené pre_intervention_","either":"buď/alebo ","strong":"silné ","strong_against":"Silné proti_intervention_","strong_for":"Silné pre_intervention_"},"messages":{"switch_to_auto":"Názov_sectionName_bol upravený ručne.<br>Môžete sa vrátiť k automatickému generovaniu _sectionName_<br> Ak sa rozhodnete pre automatické generovanie, akékoľvek ručne urobené zmeny,_sectionName_ ktoré ste doteraz urobili, budú zrušené.","switch_to_manual":"Názov_sectionName_bol vygenerovaný automaticky.<br>Môžete upraviť názov_sectionName_sám.<br> Pokiaľ sa rozhodnete upraviť to ručne, už viac nebude automaticky meniť.  "},"placeholders":{"presentation_name":"Názov prezentácie... "},"presentation_name":"Názov prezentácie","recommendation":"Odporúčanie","recommendation_strength":"Súvisiace odporúčania","recommendations":{"conduct_pilot_study":"Vykonať pilotnú štúdiu o tejto možnosti","cover":"Kryť","cover_with_evidence":"Kryť s tvorbou dôkazov","cover_with_price":"Kryť vyjednávaním o cene","do_not_cover":"Nekryť","do_not_implement":"Nezaviesť možnosť","implement":"Zaviesť možnosť","implement_with_evaluation":"Zavádzať možnosť s hodnotením dopadu","postpone":"Odložiť rozhodnutie","recommend":"Odporúčame intervenciu ","recommend_against":"Odporúčame nerobiť intervenciu alebo porovnávanie","restricted_coverage":"Obmedzené krytie","suggest":"Navrhujeme intervenciu ","suggest_against":"Navrhujeme nepoužiť intervenciu alebo použiť porovnanie","suggest_either":"Navrhujeme buď intervenciu alebo porovnanie","why_this_recommendation":"Prečo_recommendation_"},"section_titles":{"for_decision":"_sectionName_pre rozhodnutie ","for_recommendation":" _sectionName_pre odporúčanie","related_recommendations":"Súvisiace odporúčanie(a)"},"titles":{"add_item":"Pridať položku","add_topic":"Pridať tému","publicationDate":"Dátum zverejnenia","remove":"Odstrániť"}}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = {"actions":{"add":"增加","apply":"应用","cancel":"取消"},"additional_guidance":"指导建议","buttons":{"cancel":"取消","change_to_auto":"切换为自动生成","change_to_manual":"切换为手动编辑","close_benefits_and_harms":"关闭利弊权衡说明","close_table":"关闭表格","confirm":"确认","keep_auto":"保持自动生成","keep_manual":"保持手动编辑","ok":"好的","open_table":"点击此处打开表格","see_benefits_and_harms":"通过数字对比利弊","switch_to_auto":"切换到自动","switch_to_manual":"切换到手动"},"default_content":{"additional_guidance_description":"指导建议是可以帮助人们做出健康和医疗保健选择的总结性陈述。指导建议可能会有文献支持，但是多数情况下缺失推荐意见与证据之间的关联信息。","gps_description":"良好实践声明有助于人们做出健康决策。良好实践声明有系统的制定流程，但是并没有对所有证据进行系统评价。","recommendation_description":"推荐意见分为强推荐和有条件推荐。强推荐代表绝大多数人都愿意遵循该推荐意见。有条件推荐代表，虽然大部分人愿意遵循该推荐意见，但实际应用该推荐意见之前会先咨询专业医护人员。","speak_with_healthcare_professional_content":"为了决定是否应接受干预措施，可以与专业医疗人员沟通：","what_you_can_do_content":"为了判断是否患病以及其影响，有必要与专业医疗人员进行沟通。","why_this_recommendation_content":"此项建议推荐（使用/不使用）（干预），因为总体的（益处/危害）（可能大于/可能小于）（进行/没有）（干预）的情况。"},"editor":{"collapse_table":"折叠表格","expand_table":"展开表格","labels":{"ul":"UI"},"open_table_in_new_window":"在新窗口中打开表格","outcome":"结局","outcomes":"结局","table":"表格"},"good_practice_statement":"良好实践声明","labels":{"conditional":"有条件推荐","conditional_against":"有条件反对__intervention__","conditional_for":"有条件推荐 __intervention__","either":"或者","strong":"强","strong_against":"强反对 __intervention__","strong_for":"强推荐 __intervention__"},"placeholders":{"presentation_name":"简明推荐意见名称"},"presentation_name":"简明推荐意见名称","recommendation":"推荐意见","recommendation_strength":"推荐强度","recommendations":{"conduct_pilot_study":"对该选择进行预实验","cover":"覆盖；掩埋； 包括","cover_with_evidence":"证据形成","cover_with_price":"价格谈判","do_not_cover":"不覆盖；不掩盖；未覆盖；未涉及","do_not_implement":"不执行该选择","implement":"实施选择","implement_with_evaluation":"基于影响评估实施干预","postpone":"推迟决策","recommend":"我们推荐干预措施","recommend_against":"我们不推荐采取干预或推荐对照措施","restricted_coverage":"有限的范围","suggest":"我们建议使用干预措施","suggest_against":"我们不建议采用干预措施或推荐对照措施","suggest_either":"我们建议干预或者对照","why_this_recommendation":"推荐说明 __recommendation__"},"section_titles":{"related_recommendations":"推荐意见"},"titles":{"add_item":"增加条目","add_topic":"增加主题","publicationDate":"发布日期","remove":"删除"}}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
//# sourceMappingURL=presentations.js.map